function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "backdrops"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "mobile"
});

var SvgTouristArrivalPhBumpchartWorldwideWide = function SvgTouristArrivalPhBumpchartWorldwideWide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 800",
    style: {
      enableBackground: "new 0 0 1366 800"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "main",
    style: {
      display: "none"
    }
  }), React.createElement("g", {
    id: "guides",
    style: {
      display: "none"
    }
  }), _ref2, React.createElement("g", {
    id: "elements"
  }, _ref3, React.createElement("g", {
    id: "wide"
  }, React.createElement("g", {
    id: "bumpchart-world"
  }, React.createElement("g", {
    id: "XMLID_84_"
  }, React.createElement("path", {
    id: "XMLID_1674_",
    style: {
      opacity: 0.75,
      fill: "#D5443F"
    },
    d: "M46.6,469.4c9.8,0,9.8,39.4,19.6,39.4c18.7,0,18.7-35,37.3-35 c9.5,0,9.5,6,19,6c9.8,0,9.8-5.2,19.6-5.2c9.5,0,9.5,35,19,35c9.8,0,9.8,11.5,19.6,11.5c9.8,0,9.8,8.3,19.6,8.3 c9.5,0,9.5-32.3,19-32.3c9.8,0,9.8-15.8,19.6-15.8c9.5,0,9.5-3.2,19-3.2c19.6,0,19.6,42,39.2,42c8.9,0,8.9-31.8,17.7-31.8 c19.3,0,19.3-4.5,38.6-4.5c9.8,0,9.8,15.5,19.6,15.5c9.5,0,9.5,20,19,20c9.8,0,9.8,22.3,19.6,22.3c9.8,0,9.8,17.5,19.6,17.5 c9.5,0,9.5-35.6,19-35.6c9.8,0,9.8-9.5,19.6-9.5c9.5,0,9.5-14.3,19-14.3c9.8,0,9.8-12.1,19.6-12.1c9.8,0,9.8,35.4,19.6,35.4 c9.2,0,9.2-16.9,18.4-16.9c9.8,0,9.8-2.4,19.6-2.4c9.5,0,9.5-6.2,19-6.2c9.8,0,9.8,51.2,19.6,51.2c9.5,0,9.5,3.5,19,3.5 c9.8,0,9.8,5.1,19.6,5.1c9.8,0,9.8-42,19.6-42c9.5,0,9.5-14,19-14c9.8,0,9.8-6.5,19.6-6.5c9.5,0,9.5-15.1,19-15.1 c9.8,0,9.8,35.9,19.6,35.9s9.8,21.4,19.6,21.4c8.9,0,8.9-11.1,17.7-11.1c9.8,0,9.8-15.8,19.6-15.8c9.5,0,9.5,10.4,19,10.4 c9.8,0,9.8,43.5,19.6,43.5c9.5,0,9.5-13.9,19-13.9c9.8,0,9.8,21.4,19.6,21.4c9.8,0,9.8-28.7,19.6-28.7c9.5,0,9.5-7.5,19-7.5 c29.1,0,29.1,19.8,58.2,19.8c9.8,0,9.8,18.4,19.6,18.4c18.7,0,18.7-20.5,37.3-20.5c9.5,0,9.5-43.7,19-43.7 c9.8,0,9.8,58.1,19.6,58.1c9.5,0,9.5-28.7,19-28.7c9.8,0,9.8,14.7,19.6,14.7s9.8,14.3,19.6,14.3c9.5,0,9.5-39.5,19-39.5 c9.8,0,9.8-27.1,19.6-27.1c9.5,0,9.5,9,19,9V482c-9.5,0-9.5,1.5-19,1.5c-9.8,0-9.8,30.1-19.6,30.1c-9.5,0-9.5,43.5-19,43.5 c-9.8,0-9.8-15.7-19.6-15.7s-9.8-19-19.6-19c-9.5,0-9.5,33.8-19,33.8c-9.8,0-9.8-65.3-19.6-65.3c-9.5,0-9.5,44-19,44 c-18.7,0-18.7,20.3-37.3,20.3c-9.8,0-9.9-23.3-19.7-23.3c-29.1,0-29-9-58.1-9c-9.5,0-9.5,9.8-19,9.8c-9.8,0-9.8,28.4-19.6,28.4 c-9.8,0-9.8-25.4-19.6-25.4c-9.5,0-9.5,18-19,18c-9.8,0-9.8-49.2-19.6-49.2c-9.5,0-9.5-13.2-19-13.2c-9.8,0-9.8,18-19.6,18 c-8.9,0-8.9,9.7-17.7,9.7c-9.8,0-9.8-26.5-19.6-26.5s-9.8-35.5-19.6-35.5c-9.5,0-9.5,23.5-19,23.5c-9.8,0-9.8,8.3-19.6,8.3 c-9.5,0-9.5,17.4-19,17.4c-9.8,0-9.8,41.5-19.6,41.5c-9.8,0-9.8-7.5-19.6-7.5c-9.5,0-9.5-0.2-19-0.2c-9.8,0-9.8-55.9-19.6-55.9 c-9.5,0-9.5,5.3-19,5.3c-9.8,0-9.8,1-19.6,1c-9.2,0-9.2,17.7-18.4,17.7c-9.8,0-9.8-40.6-19.6-40.6c-9.8,0-9.8,20.6-19.6,20.6 c-9.5,0-9.5,15.4-19,15.4c-9.8,0-9.8,12.8-19.6,12.8c-9.5,0-9.5,34.3-19,34.3c-9.8,0-9.8-19.7-19.6-19.7 c-9.8,0-9.8-19.4-19.6-19.4c-9.5,0-9.5-24.7-19-24.7c-9.8,0-9.8-16.3-19.6-16.3c-19.3,0-19.3,2.9-38.6,2.9 c-8.9,0-8.9,34.2-17.7,34.2c-19.6,0-19.6-41.2-39.2-41.2c-9.5,0-9.5,5.1-19,5.1c-9.8,0-9.8,18.6-19.6,18.6 c-9.5,0-9.5,32.2-19,32.2c-9.8,0-9.8-11.3-19.6-11.3c-9.8,0-9.8-8.8-19.6-8.8c-9.5,0-9.5-38.5-19-38.5c-9.8,0-9.8,2.9-19.6,2.9 c-9.5,0-9.5-6.6-19-6.6c-18.7,0-18.7,37.2-37.3,37.2c-9.8,0-9.8-43.6-19.6-43.6V469.4z"
  }), React.createElement("path", {
    id: "XMLID_1658_",
    style: {
      opacity: 0.75,
      fill: "#D5443F"
    },
    d: "M46.6,367.9c9.8,0,9.8-24.4,19.6-24.4c18.7,0,18.7-7.2,37.3-7.2 c9.5,0,9.5,10,19,10c9.8,0,9.8,3.7,19.6,3.7c9.5,0,9.5,10.9,19,10.9c9.8,0,9.8-5.2,19.6-5.2c9.8,0,9.8,48.4,19.6,48.4 c9.5,0,9.5-57.4,19-57.4c9.8,0,9.8,9.7,19.6,9.7c9.5,0,9.5-3.2,19-3.2c19.6,0,19.6-3.2,39.2-3.2c8.9,0,8.9-8.9,17.7-8.9 c19.3,0,19.3,4.1,38.6,4.1c9.8,0,9.8,3,19.6,3c9.5,0,9.5,10.7,19,10.7c9.8,0,9.8,44.7,19.6,44.7c9.8,0,9.8,57,19.6,57 c9.5,0,9.5-76.1,19-76.1c9.8,0,9.8-36.7,19.6-36.7c9.5,0,9.5,0.7,19,0.7c9.8,0,9.8,27.9,19.6,27.9c9.8,0,9.8,33.7,19.6,33.7 c9.2,0,9.2-82.9,18.4-82.9c9.8,0,9.8,5.8,19.6,5.8c9.5,0,9.5,7.5,19,7.5c9.8,0,9.8,9.3,19.6,9.3c9.5,0,9.5,68.9,19,68.9 c9.8,0,9.8,43.9,19.6,43.9c9.8,0,9.8-64.8,19.6-64.8c9.5,0,9.5-44.3,19-44.3c9.8,0,9.8-3,19.6-3c9.5,0,9.5,16.6,19,16.6 c9.8,0,9.8-10.6,19.6-10.6s9.8-17.9,19.6-17.9c8.9,0,8.9-8.8,17.7-8.8c9.8,0,9.8-1.1,19.6-1.1c9.5,0,9.5,8.1,19,8.1 c9.8,0,9.8,31.9,19.6,31.9c9.5,0,9.5,60.4,19,60.4c9.8,0,9.8,45.8,19.6,45.8c9.8,0,9.8-64.4,19.6-64.4c9.5,0,9.5,15.1,19,15.1 c29.1,0,29.1,44.3,58.2,44.3c9.8,0,9.8-29.2,19.6-29.2c18.7,0,18.7-3.6,37.3-3.6c9.5,0,9.5-18.9,19-18.9 c9.8,0,9.8-79.6,19.6-79.6c9.5,0,9.5-15.3,19-15.3c9.8,0,9.8,93,19.6,93s9.8,4.1,19.6,4.1c9.5,0,9.5,5.3,19,5.3 c9.8,0,9.8-13,19.6-13c9.5,0,9.5-80.3,19-80.3v-100c-9.5,0-9.5,104.7-19,104.7c-9.8,0-9.8,15.8-19.6,15.8 c-9.5,0-9.5,10.4-19,10.4c-9.8,0-9.8-9.8-19.6-9.8s-9.8-118-19.6-118c-9.5,0-9.5,12.6-19,12.6c-9.8,0-9.8,81.3-19.6,81.3 c-9.5,0-9.5,25.8-19,25.8c-18.7,0-18.7,4.3-37.3,4.3c-9.8,0-9.8,6-19.6,6c-29.1,0-29.1-4.6-58.2-4.6c-9.5,0-9.5-4.8-19-4.8 c-9.8,0-9.8,60-19.6,60c-9.8,0-9.8-69.4-19.6-69.4c-9.5,0-9.5-59.1-19-59.1c-9.8,0-9.8-30.4-19.6-30.4c-9.5,0-9.5-12.5-19-12.5 c-9.8,0-9.8,10.1-19.6,10.1c-8.9,0-8.9,6.6-17.7,6.6c-9.8,0-9.8-0.3-19.6-0.3s-9.8,12.3-19.6,12.3c-9.5,0-9.5,11.9-19,11.9 c-9.8,0-9.8,2.9-19.6,2.9c-9.5,0-9.5,59.7-19,59.7c-9.8,0-9.8,61.7-19.6,61.7c-9.8,0-9.8-62.8-19.6-62.8 c-9.5,0-9.5-70.5-19-70.5c-9.8,0-9.8-6.4-19.6-6.4c-9.5,0-9.5-6.6-19-6.6c-9.8,0-9.8-8.4-19.6-8.4c-9.2,0-9.2,86.9-18.4,86.9 c-9.8,0-9.8-46.3-19.6-46.3c-9.8,0-9.8-0.1-19.6-0.1c-9.5,0-9.5-4.2-19-4.2c-9.8,0-9.8,49-19.6,49c-9.5,0-9.5,72.5-19,72.5 c-9.8,0-9.8-71.5-19.6-71.5c-9.8,0-9.8-44.7-19.6-44.7c-9.5,0-9.5-12.7-19-12.7c-9.8,0-9.8-5.2-19.6-5.2 c-19.3,0-19.3-6.3-38.6-6.3c-8.9,0-8.9,15.1-17.7,15.1c-19.6,0-19.6,13.1-39.2,13.1c-9.5,0-9.5,2.4-19,2.4 c-9.8,0-9.8,2.6-19.6,2.6c-9.5,0-9.5,57-19,57c-9.8,0-9.8-64.5-19.6-64.5c-9.8,0-9.8,3.8-19.6,3.8c-9.5,0-9.5-9.9-19-9.9 c-9.8,0-9.8-10.2-19.6-10.2c-9.5,0-9.5-10-19-10c-18.7,0-18.7,13.4-37.3,13.4c-9.8,0-9.8,14.7-19.6,14.7V367.9z"
  }), React.createElement("path", {
    id: "XMLID_1672_",
    style: {
      opacity: 0.75,
      fill: "#9C27B0"
    },
    d: "M46.6,553.7c9.8,0,9.8-7.2,19.6-7.2c18.7,0,18.7,3.4,37.3,3.4 c9.5,0,9.5-1.2,19-1.2c9.8,0,9.8-1.3,19.6-1.3c9.5,0,9.5-8.9,19-8.9c9.8,0,9.8,32.6,19.6,32.6c9.8,0,9.8-2.4,19.6-2.4 c9.5,0,9.5-39.8,19-39.8c9.8,0,9.8,15.3,19.6,15.3c9.5,0,9.5-9.4,19-9.4c19.6,0,19.6,26.2,39.2,26.2c8.9,0,8.9-6.5,17.7-6.5 c19.3,0,19.3-1.9,38.6-1.9c9.8,0,9.8,7.9,19.6,7.9c9.5,0,9.5-4.5,19-4.5c9.8,0,9.8,35.8,19.6,35.8c9.8,0,9.8,4.2,19.6,4.2 c9.5,0,9.5-30.4,19-30.4c9.8,0,9.8-4.1,19.6-4.1c9.5,0,9.5-1.5,19-1.5c9.8,0,9.8,23,19.6,23c9.8,0,9.8,17.7,19.6,17.7 c9.2,0,9.2-23.4,18.4-23.4c9.8,0,9.8-10.6,19.6-10.6c9.5,0,9.5-3.2,19-3.2c9.8,0,9.8,25.6,19.6,25.6c9.5,0,9.5,28,19,28 c9.8,0,9.8-8.7,19.6-8.7c9.8,0,9.8-30,19.6-30c9.5,0,9.5-19.3,19-19.3c9.8,0,9.8,21,19.6,21c9.5,0,9.5,23,19,23 c9.8,0,9.8,19.5,19.6,19.5s9.8-21.4,19.6-21.4c8.9,0,8.9-7.2,17.7-7.2c9.8,0,9.8,6.6,19.6,6.6c9.5,0,9.5,7.9,19,7.9 c9.8,0,9.8-38.3,19.6-38.3c9.5,0,9.5,61.4,19,61.4c9.8,0,9.8-8.9,19.6-8.9c9.8,0,9.8-27.9,19.6-27.9c9.5,0,9.5,19.9,19,19.9 c29.1,0,29.1,52,58.2,52c9.8,0,9.8-11.2,19.6-11.2c18.7,0,18.7-25.3,37.3-25.3c9.5,0,9.5-21.9,19-21.9c9.8,0,9.8-0.2,19.6-0.2 c9.5,0,9.5,26.2,19,26.2c9.8,0,9.8-5.8,19.6-5.8s9.8-15.4,19.6-15.4c9.5,0,9.5,8.6,19,8.6c9.8,0,9.8-8.2,19.6-8.2 c9.5,0,9.5,14,19,14v-5.4c-9.5,0-9.5-13-19-13c-9.8,0-9.8,9.3-19.6,9.3c-9.5,0-9.5-9.7-19-9.7c-9.8,0-9.8,14.7-19.6,14.7 s-9.8,7.7-19.6,7.7c-9.5,0-9.5-28.3-19-28.3c-9.8,0-9.8-2.8-19.6-2.8c-9.5,0-9.5,30.1-19,30.1c-18.7,0-18.7,16-37.3,16 c-9.8,0-9.8,12.4-19.6,12.4c-29.1,0-29.1-46.7-58.2-46.7c-9.5,0-9.5-20.7-19-20.7c-9.8,0-9.8,27.1-19.6,27.1 c-9.8,0-9.8,10.4-19.6,10.4c-9.5,0-9.5-58.6-19-58.6c-9.8,0-9.8,33.9-19.6,33.9c-9.5,0-9.5-10.7-19-10.7 c-9.8,0-9.8-6.8-19.6-6.8c-8.9,0-8.9,6.5-17.7,6.5c-9.8,0-9.8,22.4-19.6,22.4s-9.8-18.2-19.6-18.2c-9.5,0-9.5-21.4-19-21.4 c-9.8,0-9.8-20.6-19.6-20.6c-9.5,0-9.5,20.8-19,20.8c-9.8,0-9.8,29-19.6,29c-9.8,0-9.8,7.9-19.6,7.9c-9.5,0-9.5-26.7-19-26.7 c-9.8,0-9.8-27.1-19.6-27.1c-9.5,0-9.5,2.1-19,2.1c-9.8,0-9.8,10.3-19.6,10.3c-9.2,0-9.2,22.2-18.4,22.2c-9.8,0-9.8-16-19.6-16 c-9.8,0-9.8-21-19.6-21c-9.5,0-9.5,1.8-19,1.8c-9.8,0-9.8,4.8-19.6,4.8c-9.5,0-9.5,29.7-19,29.7c-9.8,0-9.8-4.9-19.6-4.9 c-9.8,0-9.8-34.5-19.6-34.5c-9.5,0-9.5,3.5-19,3.5c-9.8,0-9.8-8.7-19.6-8.7c-19.3,0-19.3,1.6-38.6,1.6c-8.9,0-8.9,5.4-17.7,5.4 c-19.6,0-19.6-24.7-39.2-24.7c-9.5,0-9.5,10.7-19,10.7c-9.8,0-9.8-14.8-19.6-14.8c-9.5,0-9.5,40.2-19,40.2 c-9.8,0-9.8,1.8-19.6,1.8c-9.8,0-9.8-33.3-19.6-33.3c-9.5,0-9.5,9.9-19,9.9c-9.8,0-9.8,0.9-19.6,0.9c-9.5,0-9.5,0.3-19,0.3 c-18.7,0-18.7-3.9-37.3-3.9c-9.8,0-9.8,7.1-19.6,7.1V553.7z"
  }), React.createElement("path", {
    id: "XMLID_1671_",
    style: {
      opacity: 0.75,
      fill: "#9C27B0"
    },
    d: "M46.6,541.2c9.8,0,9.8-0.3,19.6-0.3c18.7,0,18.7-8.4,37.3-8.4 c9.5,0,9.5-8,19-8c9.8,0,9.8,10.4,19.6,10.4c9.5,0,9.5-18.8,19-18.8c9.8,0,9.8,29.6,19.6,29.6c9.8,0,9.8,2,19.6,2 c9.5,0,9.5-44.1,19-44.1c9.8,0,9.8,14.8,19.6,14.8c9.5,0,9.5,4.3,19,4.3c19.6,0,19.6,31.1,39.2,31.1c8.9,0,8.9-13.2,17.7-13.2 c19.3,0,19.3,0.3,38.6,0.3c9.8,0,9.8-1.4,19.6-1.4c9.5,0,9.5-1.8,19-1.8c9.8,0,9.8,37.5,19.6,37.5c9.8,0,9.8-1.7,19.6-1.7 c9.5,0,9.5-29.8,19-29.8c9.8,0,9.8-3.3,19.6-3.3c9.5,0,9.5-1.1,19-1.1c9.8,0,9.8,27.4,19.6,27.4c9.8,0,9.8,25.4,19.6,25.4 c9.2,0,9.2-30.5,18.4-30.5c9.8,0,9.8-2,19.6-2c9.5,0,9.5-8.1,19-8.1c9.8,0,9.8,17.3,19.6,17.3c9.5,0,9.5,36.5,19,36.5 c9.8,0,9.8-13.2,19.6-13.2c9.8,0,9.8-35.7,19.6-35.7c9.5,0,9.5-2.8,19-2.8c9.8,0,9.8,14,19.6,14c9.5,0,9.5,9,19,9 c9.8,0,9.8,37.2,19.6,37.2s9.8-22.4,19.6-22.4c8.9,0,8.9-6.5,17.7-6.5c9.8,0,9.8,6.8,19.6,6.8c9.5,0,9.5,4.3,19,4.3 c9.8,0,9.8-24.2,19.6-24.2c9.5,0,9.5,29.5,19,29.5c9.8,0,9.8,9.1,19.6,9.1c9.8,0,9.8-32.5,19.6-32.5c9.5,0,9.5,26.8,19,26.8 c29.1,0,29.1,52.3,58.2,52.3c9.8,0,9.8-12.4,19.6-12.4c18.7,0,18.7-12.7,37.3-12.7c9.5,0,9.5-14.6,19-14.6 c9.8,0,9.8-31.1,19.6-31.1c9.5,0,9.5,32,19,32c9.8,0,9.8-3,19.6-3s9.8-20.8,19.6-20.8c9.5,0,9.5,11.4,19,11.4 c9.8,0,9.8-12.2,19.6-12.2c9.5,0,9.5,19.3,19,19.3v-7.5c-9.5,0-9.5-18.2-19-18.2c-9.8,0-9.8,13.4-19.6,13.4c-9.5,0-9.5-12-19-12 c-9.8,0-9.8,20.5-19.6,20.5s-9.8,4.6-19.6,4.6c-9.5,0-9.5-33.6-19-33.6c-9.8,0-9.8,30.1-19.6,30.1c-9.5,0-9.5,21.9-19,21.9 c-18.7,0-18.7,3.3-37.3,3.3c-9.8,0-9.8,13.4-19.6,13.4c-29.1,0-29.1-48.3-58.2-48.3c-9.5,0-9.5-27.7-19-27.7 c-9.8,0-9.8,32-19.6,32c-9.8,0-9.8-7.7-19.6-7.7c-9.5,0-9.5-25.2-19-25.2c-9.8,0-9.8,18.6-19.6,18.6c-9.5,0-9.5-6.6-19-6.6 c-9.8,0-9.8-8.8-19.6-8.8c-8.9,0-8.9,6.9-17.7,6.9c-9.8,0-9.8,23.5-19.6,23.5s-9.8-38.3-19.6-38.3c-9.5,0-9.5-6.4-19-6.4 c-9.8,0-9.8-13.2-19.6-13.2c-9.5,0-9.5,4.6-19,4.6c-9.8,0-9.8,34.7-19.6,34.7c-9.8,0-9.8,12.9-19.6,12.9 c-9.5,0-9.5-34.6-19-34.6c-9.8,0-9.8-19-19.6-19c-9.5,0-9.5,7-19,7c-9.8,0-9.8-1.2-19.6-1.2c-9.2,0-9.2,31-18.4,31 c-9.8,0-9.8-23.9-19.6-23.9c-9.8,0-9.8-26.1-19.6-26.1c-9.5,0-9.5,2.4-19,2.4c-9.8,0-9.8,4.6-19.6,4.6c-9.5,0-9.5,28.4-19,28.4 c-9.8,0-9.8,2.5-19.6,2.5c-9.8,0-9.8-36.6-19.6-36.6c-9.5,0-9.5,0.6-19,0.6c-9.8,0-9.8,0.9-19.6,0.9c-19.3,0-19.3-3.1-38.6-3.1 c-8.9,0-8.9,14.3-17.7,14.3c-19.6,0-19.6-32.4-39.2-32.4c-9.5,0-9.5-1.9-19-1.9c-9.8,0-9.8-13.6-19.6-13.6 c-9.5,0-9.5,44.8-19,44.8c-9.8,0-9.8-3.2-19.6-3.2c-9.8,0-9.8-29.2-19.6-29.2c-9.5,0-9.5,20.1-19,20.1 c-9.8,0-9.8-11.3-19.6-11.3c-9.5,0-9.5,6.2-19,6.2c-18.7,0-18.7,7.1-37.3,7.1c-9.8,0-9.8,0.4-19.6,0.4V541.2z"
  }), React.createElement("path", {
    id: "XMLID_1663_",
    style: {
      opacity: 0.75,
      fill: "#9C27B0"
    },
    d: "M46.6,577c9.8,0,9.8,2.9,19.6,2.9c18.7,0,18.7-8.7,37.3-8.7 c9.5,0,9.5-15.2,19-15.2c9.8,0,9.8-5.4,19.6-5.4c9.5,0,9.5-3.3,19-3.3c9.8,0,9.8,30.8,19.6,30.8c9.8,0,9.8-6.3,19.6-6.3 c9.5,0,9.5-32,19-32c9.8,0,9.8,12.3,19.6,12.3c9.5,0,9.5,2.7,19,2.7c19.6,0,19.6,40.4,39.2,40.4c8.9,0,8.9-15.6,17.7-15.6 c19.3,0,19.3-8.9,38.6-8.9c9.8,0,9.8,2.1,19.6,2.1c9.5,0,9.5-9.9,19-9.9c9.8,0,9.8,37.8,19.6,37.8c9.8,0,9.8,6,19.6,6 c9.5,0,9.5-38.2,19-38.2c9.8,0,9.8,4.6,19.6,4.6c9.5,0,9.5-5.1,19-5.1c9.8,0,9.8,36.6,19.6,36.6c9.8,0,9.8,28.1,19.6,28.1 c9.2,0,9.2-34.5,18.4-34.5c9.8,0,9.8-1,19.6-1c9.5,0,9.5-9.8,19-9.8c9.8,0,9.8,4.7,19.6,4.7c9.5,0,9.5,39.7,19,39.7 c9.8,0,9.8-11.9,19.6-11.9c9.8,0,9.8-38.6,19.6-38.6c9.5,0,9.5,4.9,19,4.9c9.8,0,9.8,8.7,19.6,8.7c9.5,0,9.5,13.2,19,13.2 c9.8,0,9.8,31.6,19.6,31.6s9.8,5.7,19.6,5.7c8.9,0,8.9-7.5,17.7-7.5c9.8,0,9.8-7.7,19.6-7.7c9.5,0,9.5,2.5,19,2.5 c9.8,0,9.8-54.6,19.6-54.6c9.5,0,9.5,56.8,19,56.8c9.8,0,9.8,3.1,19.6,3.1c9.8,0,9.8-31.2,19.6-31.2c9.5,0,9.5,19.9,19,19.9 c29.1,0,29.1,64.4,58.2,64.4c9.8,0,9.8,7.7,19.6,7.7c18.7,0,18.7-63.8,37.3-63.8c9.5,0,9.5,14.8,19,14.8 c9.8,0,9.8-25.9,19.6-25.9c9.5,0,9.5,14.2,19,14.2c9.8,0,9.8,8.3,19.6,8.3s9.8-18.3,19.6-18.3c9.5,0,9.5,1.9,19,1.9 c9.8,0,9.8-1.7,19.6-1.7c9.5,0,9.5,21.6,19,21.6v-3.4c-9.5,0-9.5-20.9-19-20.9c-9.8,0-9.8,2.4-19.6,2.4c-9.5,0-9.5-2.3-19-2.3 c-9.8,0-9.8,16.9-19.6,16.9s-9.8-6.6-19.6-6.6c-9.5,0-9.5-14.9-19-14.9c-9.8,0-9.8,25.5-19.6,25.5c-9.5,0-9.5-11.5-19-11.5 c-18.7,0-18.7,61.1-37.3,61.1c-9.8,0-9.8-8.3-19.6-8.3c-29.1,0-29.1-62.9-58.2-62.9c-9.5,0-9.5-20.1-19-20.1 c-9.8,0-9.8,30.2-19.6,30.2c-9.8,0-9.8-1.9-19.6-1.9c-9.5,0-9.5-54.9-19-54.9c-9.8,0-9.8,52-19.6,52c-9.5,0-9.5-3.1-19-3.1 c-9.8,0-9.8,8.1-19.6,8.1c-8.9,0-8.9,7.4-17.7,7.4c-9.8,0-9.8-6.5-19.6-6.5s-9.8-31.5-19.6-31.5c-9.5,0-9.5-12.4-19-12.4 c-9.8,0-9.8-8.3-19.6-8.3c-9.5,0-9.5-4-19-4c-9.8,0-9.8,38.1-19.6,38.1c-9.8,0-9.8,10.8-19.6,10.8c-9.5,0-9.5-38.3-19-38.3 c-9.8,0-9.8-5.2-19.6-5.2c-9.5,0-9.5,9.3-19,9.3c-9.8,0-9.8,1-19.6,1c-9.2,0-9.2,34.6-18.4,34.6c-9.8,0-9.8-28.5-19.6-28.5 c-9.8,0-9.8-36-19.6-36c-9.5,0-9.5,5.6-19,5.6c-9.8,0-9.8-4.2-19.6-4.2c-9.5,0-9.5,38.1-19,38.1c-9.8,0-9.8-7-19.6-7 c-9.8,0-9.8-36.8-19.6-36.8c-9.5,0-9.5,9.4-19,9.4c-9.8,0-9.8-2.3-19.6-2.3c-19.3,0-19.3,9-38.6,9c-8.9,0-8.9,15.6-17.7,15.6 c-19.6,0-19.6-41.4-39.2-41.4c-9.5,0-9.5-1.7-19-1.7c-9.8,0-9.8-11.9-19.6-11.9c-9.5,0-9.5,32.2-19,32.2 c-9.8,0-9.8,6.4-19.6,6.4c-9.8,0-9.8-32-19.6-32c-9.5,0-9.5,4.3-19,4.3c-9.8,0-9.8,5.1-19.6,5.1c-9.5,0-9.5,15-19,15 c-18.7,0-18.7,8.8-37.3,8.8c-9.8,0-9.8-3-19.6-3V577z"
  }), React.createElement("path", {
    id: "XMLID_1657_",
    style: {
      opacity: 0.75,
      fill: "#9C27B0"
    },
    d: "M46.6,522.3c9.8,0,9.8-39.9,19.6-39.9c18.7,0,18.7,5.6,37.3,5.6 c9.5,0,9.5-23,19-23c9.8,0,9.8,32.5,19.6,32.5c9.5,0,9.5,3.1,19,3.1c9.8,0,9.8-3.7,19.6-3.7c9.8,0,9.8,13.5,19.6,13.5 c9.5,0,9.5-21.9,19-21.9c9.8,0,9.8,14,19.6,14c9.5,0,9.5,10.1,19,10.1c19.6,0,19.6,20.1,39.2,20.1c8.9,0,8.9-60.9,17.7-60.9 c19.3,0,19.3-2.9,38.6-2.9c9.8,0,9.8,43.9,19.6,43.9c9.5,0,9.5-12.8,19-12.8c9.8,0,9.8-0.3,19.6-0.3c9.8,0,9.8,37.9,19.6,37.9 c9.5,0,9.5-23,19-23c9.8,0,9.8-12.8,19.6-12.8c9.5,0,9.5,10.9,19,10.9c9.8,0,9.8,7.5,19.6,7.5c9.8,0,9.8,33,19.6,33 c9.2,0,9.2-101.4,18.4-101.4c9.8,0,9.8,66.9,19.6,66.9c9.5,0,9.5-6.9,19-6.9c9.8,0,9.8,15.1,19.6,15.1c9.5,0,9.5-3.5,19-3.5 c9.8,0,9.8,10.7,19.6,10.7c9.8,0,9.8-8.3,19.6-8.3c9.5,0,9.5-38.7,19-38.7c9.8,0,9.8,38.3,19.6,38.3c9.5,0,9.5-5,19-5 c9.8,0,9.8,34.5,19.6,34.5s9.8-1.7,19.6-1.7c8.9,0,8.9-10,17.7-10c9.8,0,9.8-53.6,19.6-53.6c9.5,0,9.5,63,19,63 c9.8,0,9.8-0.6,19.6-0.6c9.5,0,9.5-18,19-18c9.8,0,9.8-2.8,19.6-2.8c9.8,0,9.8-0.2,19.6-0.2c9.5,0,9.5,18.1,19,18.1 c29.1,0,29.1,44.7,58.2,44.7c9.8,0,9.8-3.9,19.6-3.9c18.7,0,18.7-18.1,37.3-18.1c9.5,0,9.5-9.9,19-9.9c9.8,0,9.8-34.8,19.6-34.8 c9.5,0,9.5-6.5,19-6.5c9.8,0,9.8,19,19.6,19s9.8,15.7,19.6,15.7c9.5,0,9.5-11.3,19-11.3c9.8,0,9.8-8.1,19.6-8.1 c9.5,0,9.5,19.9,19,19.9v-20.8c-9.5,0-9.5-14.6-19-14.6c-9.8,0-9.8,9.6-19.6,9.6c-9.5,0-9.5,14.3-19,14.3 c-9.8,0-9.8-19.3-19.6-19.3s-9.8-22.3-19.6-22.3c-9.5,0-9.5,12.4-19,12.4c-9.8,0-9.8,32.3-19.6,32.3c-9.5,0-9.5,7.4-19,7.4 c-18.7,0-18.7,20.5-37.3,20.5c-9.8,0-9.8,1.3-19.6,1.3c-29.1,0-29.1-39.5-58.2-39.5c-9.5,0-9.5-16.4-19-16.4 c-9.8,0-9.8-2.9-19.6-2.9c-9.8,0-9.8-0.2-19.6-0.2c-9.5,0-9.5,23.8-19,23.8c-9.8,0-9.8-2.3-19.6-2.3c-9.5,0-9.5-69.3-19-69.3 c-9.8,0-9.8,57.9-19.6,57.9c-8.9,0-8.9,11.1-17.7,11.1c-9.8,0-9.8,1.2-19.6,1.2s-9.8-38.1-19.6-38.1c-9.5,0-9.5,10.5-19,10.5 c-9.8,0-9.8-37.7-19.6-37.7c-9.5,0-9.5,42.4-19,42.4c-9.8,0-9.8,4.1-19.6,4.1c-9.8,0-9.8-13.8-19.6-13.8c-9.5,0-9.5,9.6-19,9.6 c-9.8,0-9.8-17.6-19.6-17.6c-9.5,0-9.5,6.2-19,6.2c-9.8,0-9.8-73.5-19.6-73.5c-9.2,0-9.2,108.7-18.4,108.7 c-9.8,0-9.8-34.9-19.6-34.9c-9.8,0-9.8-4.4-19.6-4.4c-9.5,0-9.5-10.1-19-10.1c-9.8,0-9.8,15-19.6,15c-9.5,0-9.5,19.6-19,19.6 c-9.8,0-9.8-40.7-19.6-40.7c-9.8,0-9.8,5.7-19.6,5.7c-9.5,0-9.5,10.2-19,10.2c-9.8,0-9.8-45.5-19.6-45.5 c-19.3,0-19.3,0.3-38.6,0.3c-8.9,0-8.9,66-17.7,66c-19.6,0-19.6-18.6-39.2-18.6c-9.5,0-9.5-9.4-19-9.4 c-9.8,0-9.8-12.9-19.6-12.9c-9.5,0-9.5,20.5-19,20.5c-9.8,0-9.8-16.6-19.6-16.6c-9.8,0-9.8,7.8-19.6,7.8c-9.5,0-9.5-4.9-19-4.9 c-9.8,0-9.8-35.9-19.6-35.9c-9.5,0-9.5,23.5-19,23.5c-18.7,0-18.7-4.7-37.3-4.7c-9.8,0-9.8,41-19.6,41V522.3z"
  }), React.createElement("path", {
    id: "XMLID_1673_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,416.9c9.8,0,9.8-24.4,19.6-24.4c18.7,0,18.7,25.8,37.3,25.8 c9.5,0,9.5-4.7,19-4.7c9.8,0,9.8,1.2,19.6,1.2c9.5,0,9.5,5.5,19,5.5c9.8,0,9.8-22.8,19.6-22.8c9.8,0,9.8,47,19.6,47 c9.5,0,9.5-32.8,19-32.8c9.8,0,9.8-1.3,19.6-1.3c9.5,0,9.5,1.1,19,1.1c19.6,0,19.6,25,39.2,25c8.9,0,8.9-18.6,17.7-18.6 c19.3,0,19.3-2.1,38.6-2.1c9.8,0,9.8,1.2,19.6,1.2c9.5,0,9.5,7.3,19,7.3c9.8,0,9.8-84.7,19.6-84.7c9.8,0,9.8,16.4,19.6,16.4 c9.5,0,9.5-17.4,19-17.4c9.8,0,9.8,51,19.6,51c9.5,0,9.5-3.9,19-3.9c9.8,0,9.8,38.7,19.6,38.7c9.8,0,9.8-84.3,19.6-84.3 c9.2,0,9.2,39.8,18.4,39.8c9.8,0,9.8,6.2,19.6,6.2c9.5,0,9.5,0.6,19,0.6c9.8,0,9.8,17.7,19.6,17.7c9.5,0,9.5-59.2,19-59.2 c9.8,0,9.8,62.8,19.6,62.8c9.8,0,9.8-61.7,19.6-61.7c9.5,0,9.5,51.2,19,51.2c9.8,0,9.8,0.5,19.6,0.5c9.5,0,9.5,13.8,19,13.8 c9.8,0,9.8,28.3,19.6,28.3s9.8-25.3,19.6-25.3c8.9,0,8.9-10.8,17.7-10.8c9.8,0,9.8-2.3,19.6-2.3c9.5,0,9.5,7,19,7 c9.8,0,9.8,24.7,19.6,24.7c9.5,0,9.5-88.3,19-88.3c9.8,0,9.8,6.4,19.6,6.4c9.8,0,9.8,3,19.6,3c9.5,0,9.5,4.8,19,4.8 c29.1,0,29.1,4.6,58.2,4.6c9.8,0,9.8-6,19.6-6c18.7,0,18.7-4.3,37.3-4.3c9.5,0,9.5-25.8,19-25.8c9.8,0,9.8,87,19.6,87 c9.5,0,9.5-7.9,19-7.9c9.8,0,9.8-55,19.6-55s9.8,9.8,19.6,9.8c9.5,0,9.5-10.4,19-10.4c9.8,0,9.8-15.8,19.6-15.8 c9.5,0,9.5,91.8,19,91.8V334c-9.5,0-9.5-82-19-82c-9.8,0-9.8,1.4-19.6,1.4c-9.5,0-9.5,6.2-19,6.2c-9.8,0-9.8-22.4-19.6-22.4 s-9.8,87.7-19.6,87.7c-9.5,0-9.5,15.3-19,15.3c-9.8,0-9.8-117.4-19.6-117.4c-9.5,0-9.5,21.2-19,21.2 c-18.7,0-18.7-26.3-37.3-26.3c-9.8,0-9.8,39.6-19.6,39.6c-29.1,0-29.1,15.9-58.2,15.9c-9.5,0-9.5,5.2-19,5.2 c-9.8,0-9.8-18.5-19.6-18.5c-9.8,0-9.8-1.7-19.6-1.7c-9.5,0-9.5,111.9-19,111.9c-9.8,0-9.8-31.9-19.6-31.9 c-9.5,0-9.5-8.1-19-8.1c-9.8,0-9.8,1.1-19.6,1.1c-8.9,0-8.9,8.8-17.7,8.8c-9.8,0-9.8,17.9-19.6,17.9s-9.8,10.6-19.6,10.6 c-9.5,0-9.5-16.6-19-16.6c-9.8,0-9.8,3-19.6,3c-9.5,0-9.5-59.3-19-59.3c-9.8,0-9.8,53.4-19.6,53.4c-9.8,0-9.8-82-19.6-82 c-9.5,0-9.5,84.3-19,84.3c-9.8,0-9.8-9.3-19.6-9.3c-9.5,0-9.5-7.5-19-7.5c-9.8,0-9.8-5.8-19.6-5.8c-9.2,0-9.2-67.1-18.4-67.1 c-9.8,0-9.8,116.4-19.6,116.4c-9.8,0-9.8-27.9-19.6-27.9c-9.5,0-9.5-0.7-19-0.7c-9.8,0-9.8-59.9-19.6-59.9 c-9.5,0-9.5,3.9-19,3.9c-9.8,0-9.8-17.6-19.6-17.6c-9.8,0-9.8,117.5-19.6,117.5c-9.5,0-9.5-6.4-19-6.4c-9.8,0-9.8-2.9-19.6-2.9 c-19.3,0-19.3,5.2-38.6,5.2c-8.9,0-8.9,7.3-17.7,7.3c-19.6,0-19.6-4.9-39.2-4.9c-9.5,0-9.5,0.1-19,0.1c-9.8,0-9.8-5.2-19.6-5.2 c-9.5,0-9.5,19.3-19,19.3c-9.8,0-9.8-48.4-19.6-48.4c-9.8,0-9.8,36.8-19.6,36.8c-9.5,0-9.5-8.9-19-8.9c-9.8,0-9.8-1.8-19.6-1.8 c-9.5,0-9.5-1.3-19-1.3c-18.7,0-18.7-37.1-37.3-37.1c-9.8,0-9.8,24.4-19.6,24.4V416.9z"
  }), React.createElement("path", {
    id: "XMLID_1670_",
    style: {
      opacity: 0.75,
      fill: "#FF9800"
    },
    d: "M46.6,580.2c9.8,0,9.8-12.7,19.6-12.7c18.7,0,18.7-12.8,37.3-12.8 c9.5,0,9.5-10.3,19-10.3c9.8,0,9.8-5.2,19.6-5.2c9.5,0,9.5-10.9,19-10.9c9.8,0,9.8,28.8,19.6,28.8c9.8,0,9.8,4.5,19.6,4.5 c9.5,0,9.5-28.8,19-28.8c9.8,0,9.8,15.7,19.6,15.7c9.5,0,9.5,1.7,19,1.7c19.6,0,19.6,41.4,39.2,41.4c8.9,0,8.9-7.9,17.7-7.9 c19.3,0,19.3-8.8,38.6-8.8c9.8,0,9.8-5.6,19.6-5.6c9.5,0,9.5-36.8,19-36.8c9.8,0,9.8,54.1,19.6,54.1c9.8,0,9.8,13.3,19.6,13.3 c9.5,0,9.5-41.9,19-41.9c9.8,0,9.8,7.7,19.6,7.7c9.5,0,9.5-1.5,19-1.5c9.8,0,9.8,48.1,19.6,48.1c9.8,0,9.8,24.8,19.6,24.8 c9.2,0,9.2-30.5,18.4-30.5c9.8,0,9.8-17.8,19.6-17.8c9.5,0,9.5-4.9,19-4.9c9.8,0,9.8-4.2,19.6-4.2c9.5,0,9.5,31.8,19,31.8 c9.8,0,9.8-13.1,19.6-13.1c9.8,0,9.8-31.9,19.6-31.9c9.5,0,9.5,12,19,12c9.8,0,9.8,25.3,19.6,25.3c9.5,0,9.5,19.2,19,19.2 c9.8,0,9.8,30.6,19.6,30.6s9.8-3.8,19.6-3.8c8.9,0,8.9-7.6,17.7-7.6c9.8,0,9.8-7.8,19.6-7.8c9.5,0,9.5-5.6,19-5.6 c9.8,0,9.8-60.1,19.6-60.1c9.5,0,9.5,44,19,44c9.8,0,9.8,15.8,19.6,15.8c9.8,0,9.8-25.1,19.6-25.1c9.5,0,9.5,15.8,19,15.8 c29.1,0,29.1,80,58.2,80c9.8,0,9.8-4.5,19.6-4.5c18.7,0,18.7-66,37.3-66c9.5,0,9.5,25.5,19,25.5c9.8,0,9.8-34.5,19.6-34.5 c9.5,0,9.5,10.1,19,10.1c9.8,0,9.8,21.8,19.6,21.8s9.8-20,19.6-20c9.5,0,9.5,1.9,19,1.9c9.8,0,9.8-1.3,19.6-1.3 c9.5,0,9.5,21.7,19,21.7v-2.1c-9.5,0-9.5-21.6-19-21.6c-9.8,0-9.8,1.7-19.6,1.7c-9.5,0-9.5-1.9-19-1.9 c-9.8,0-9.8,18.3-19.6,18.3s-9.8-22.3-19.6-22.3c-9.5,0-9.5-9.3-19-9.3c-9.8,0-9.8,35.1-19.6,35.1c-9.5,0-9.5-26-19-26 c-18.7,0-18.7,66.2-37.3,66.2c-9.8,0-9.8,7.3-19.6,7.3c-29.1,0-29.1-82.7-58.2-82.7c-9.5,0-9.5-15.6-19-15.6 c-9.8,0-9.8,23.6-19.6,23.6c-9.8,0-9.8-15.6-19.6-15.6c-9.5,0-9.5-42.9-19-42.9c-9.8,0-9.8,60.1-19.6,60.1 c-9.5,0-9.5,6.1-19,6.1c-9.8,0-9.8,7.7-19.6,7.7c-8.9,0-8.9,7.5-17.7,7.5c-9.8,0-9.8,6.3-19.6,6.3s-9.8-33.4-19.6-33.4 c-9.5,0-9.5-19-19-19c-9.8,0-9.8-25.2-19.6-25.2c-9.5,0-9.5-12.4-19-12.4c-9.8,0-9.8,30.4-19.6,30.4c-9.8,0-9.8,13.2-19.6,13.2 c-9.5,0-9.5-31-19-31c-9.8,0-9.8,4.9-19.6,4.9c-9.5,0-9.5,4.9-19,4.9c-9.8,0-9.8,18.5-19.6,18.5c-9.2,0-9.2,30.4-18.4,30.4 c-9.8,0-9.8-22.4-19.6-22.4c-9.8,0-9.8-50.7-19.6-50.7c-9.5,0-9.5,1.5-19,1.5c-9.8,0-9.8-7.4-19.6-7.4c-9.5,0-9.5,42-19,42 c-9.8,0-9.8-15-19.6-15c-9.8,0-9.8-54.1-19.6-54.1c-9.5,0-9.5,38-19,38c-9.8,0-9.8,6.1-19.6,6.1c-19.3,0-19.3,8.9-38.6,8.9 c-8.9,0-8.9,7.7-17.7,7.7c-19.6,0-19.6-42.2-39.2-42.2c-9.5,0-9.5-1.1-19-1.1c-9.8,0-9.8-15.3-19.6-15.3 c-9.5,0-9.5,28.5-19,28.5c-9.8,0-9.8-5.7-19.6-5.7c-9.8,0-9.8-29.4-19.6-29.4c-9.5,0-9.5,12.6-19,12.6c-9.8,0-9.8,5.2-19.6,5.2 c-9.5,0-9.5,9.8-19,9.8c-18.7,0-18.7,12.9-37.3,12.9C56.4,564.5,56.4,580.2,46.6,580.2z"
  }), React.createElement("path", {
    id: "XMLID_1669_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,510.1c9.8,0,9.8,21.7,19.6,21.7c18.7,0,18.7-7.1,37.3-7.1 c9.5,0,9.5-12.9,19-12.9c9.8,0,9.8-5,19.6-5c9.5,0,9.5-15.8,19-15.8c9.8,0,9.8,40.1,19.6,40.1c9.8,0,9.8-10.4,19.6-10.4 c9.5,0,9.5-41.4,19-41.4c9.8,0,9.8,12.9,19.6,12.9c9.5,0,9.5,9.4,19,9.4c19.6,0,19.6,4.4,39.2,4.4c8.9,0,8.9,24.7,17.7,24.7 c19.3,0,19.3-4.6,38.6-4.6c9.8,0,9.8-1.5,19.6-1.5c9.5,0,9.5-14.6,19-14.6c9.8,0,9.8,43.6,19.6,43.6c9.8,0,9.8-4.5,19.6-4.5 c9.5,0,9.5-44.4,19-44.4c9.8,0,9.8,20.8,19.6,20.8c9.5,0,9.5-2.9,19-2.9c9.8,0,9.8,53.5,19.6,53.5c9.8,0,9.8,4.9,19.6,4.9 c9.2,0,9.2-31,18.4-31c9.8,0,9.8-7.5,19.6-7.5c9.5,0,9.5-6.8,19-6.8c9.8,0,9.8,2.8,19.6,2.8c9.5,0,9.5,38.7,19,38.7 c9.8,0,9.8-9.5,19.6-9.5c9.8,0,9.8-32.2,19.6-32.2c9.5,0,9.5,1.6,19,1.6c9.8,0,9.8,21.6,19.6,21.6c9.5,0,9.5,27.9,19,27.9 c9.8,0,9.8,16.8,19.6,16.8s9.8,6.9,19.6,6.9c8.9,0,8.9-7.6,17.7-7.6c9.8,0,9.8-30.9,19.6-30.9c9.5,0,9.5,16.6,19,16.6 c9.8,0,9.8-15.3,19.6-15.3c9.5,0,9.5,21.9,19,21.9c9.8,0,9.8-12.6,19.6-12.6c9.8,0,9.8-29.5,19.6-29.5c9.5,0,9.5,19.9,19,19.9 c29.1,0,29.1,73.9,58.2,73.9c9.8,0,9.8-26.8,19.6-26.8c18.7,0,18.7-7.4,37.3-7.4c9.5,0,9.5-14.2,19-14.2c9.8,0,9.8-44,19.6-44 c9.5,0,9.5,33.6,19,33.6c9.8,0,9.8,11.4,19.6,11.4s9.8-12.7,19.6-12.7c9.5,0,9.5,4.4,19,4.4c9.8,0,9.8-5.8,19.6-5.8 c9.5,0,9.5,69.9,19,69.9l0,0c-9.5,0-9.5-76.7-19-76.7c-9.8,0-9.8,4.4-19.6,4.4c-9.5,0-9.5-3.3-19-3.3c-9.8,0-9.8,12.7-19.6,12.7 s-9.8-13.4-19.6-13.4c-9.5,0-9.5-36.5-19-36.5c-9.8,0-9.8,46.1-19.6,46.1c-9.5,0-9.5,14.2-19,14.2c-18.7,0-18.7,4.3-37.3,4.3 c-9.8,0-9.8,31-19.6,31c-29.1,0-29.1-73.8-58.2-73.8c-9.5,0-9.5-19.8-19-19.8c-9.8,0-9.8,28.7-19.6,28.7 c-9.8,0-9.8,14.2-19.6,14.2c-9.5,0-9.5-14.1-19-14.1c-9.8,0-9.8,6.4-19.6,6.4c-9.5,0-9.5-19.5-19-19.5 c-9.8,0-9.8,35.2-19.6,35.2c-8.9,0-8.9,7.2-17.7,7.2c-9.8,0-9.8-8.7-19.6-8.7s-9.8-15.9-19.6-15.9c-9.5,0-9.5-27.4-19-27.4 c-9.8,0-9.8-22.1-19.6-22.1c-9.5,0-9.5-1.2-19-1.2c-9.8,0-9.8,31.6-19.6,31.6c-9.8,0-9.8,8-19.6,8c-9.5,0-9.5-38.4-19-38.4 c-9.8,0-9.8-1.9-19.6-1.9c-9.5,0-9.5,7-19,7c-9.8,0-9.8,4.8-19.6,4.8c-9.2,0-9.2,30.3-18.4,30.3c-9.8,0-9.8-0.6-19.6-0.6 c-9.8,0-9.8-53.9-19.6-53.9c-9.5,0-9.5,1.3-19,1.3c-9.8,0-9.8-20.7-19.6-20.7c-9.5,0-9.5,44.3-19,44.3c-9.8,0-9.8,4-19.6,4 c-9.8,0-9.8-41.7-19.6-41.7c-9.5,0-9.5,12.8-19,12.8c-9.8,0-9.8,0.1-19.6,0.1c-19.3,0-19.3,6.1-38.6,6.1 c-8.9,0-8.9-27.3-17.7-27.3c-19.6,0-19.6-1.4-39.2-1.4c-9.5,0-9.5-9-19-9c-9.8,0-9.8-12.8-19.6-12.8c-9.5,0-9.5,41.8-19,41.8 c-9.8,0-9.8,10.7-19.6,10.7c-9.8,0-9.8-40.9-19.6-40.9c-9.5,0-9.5,17.2-19,17.2c-9.8,0-9.8,4.6-19.6,4.6 c-9.5,0-9.5,10.9-19,10.9c-18.7,0-18.7,8-37.3,8c-9.8,0-9.8-23.7-19.6-23.7V510.1z"
  }), React.createElement("path", {
    id: "XMLID_1668_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,548c9.8,0,9.8,14.8,19.6,14.8c18.7,0,18.7-23.9,37.3-23.9 c9.5,0,9.5-20.4,19-20.4c9.8,0,9.8-4.8,19.6-4.8c9.5,0,9.5,8.6,19,8.6c9.8,0,9.8,29.4,19.6,29.4c9.8,0,9.8-15.9,19.6-15.9 c9.5,0,9.5-26.3,19-26.3c9.8,0,9.8,1.2,19.6,1.2c9.5,0,9.5,18.3,19,18.3c19.6,0,19.6,38.5,39.2,38.5c8.9,0,8.9-19.3,17.7-19.3 c19.3,0,19.3-14.5,38.6-14.5c9.8,0,9.8-0.9,19.6-0.9c9.5,0,9.5-6.2,19-6.2c9.8,0,9.8,42.2,19.6,42.2c9.8,0,9.8-2.5,19.6-2.5 c9.5,0,9.5-35.4,19-35.4c9.8,0,9.8,2.5,19.6,2.5c9.5,0,9.5-2.4,19-2.4c9.8,0,9.8,26.1,19.6,26.1c9.8,0,9.8,51,19.6,51 c9.2,0,9.2-38.2,18.4-38.2c9.8,0,9.8-18.6,19.6-18.6c9.5,0,9.5-7,19-7c9.8,0,9.8,13.3,19.6,13.3c9.5,0,9.5,30.1,19,30.1 c9.8,0,9.8-2.8,19.6-2.8c9.8,0,9.8-41.3,19.6-41.3c9.5,0,9.5,2,19,2c9.8,0,9.8,3.5,19.6,3.5c9.5,0,9.5,46.4,19,46.4 c9.8,0,9.8-14.5,19.6-14.5s9.8,38.4,19.6,38.4c8.9,0,8.9-7.8,17.7-7.8c9.8,0,9.8-29.6,19.6-29.6c9.5,0,9.5-3.9,19-3.9 c9.8,0,9.8-3.2,19.6-3.2c9.5,0,9.5,10.9,19,10.9c9.8,0,9.8,7.7,19.6,7.7c9.8,0,9.8-31,19.6-31c9.5,0,9.5,30.1,19,30.1 c29.1,0,29.1,16.1,58.2,16.1c9.8,0,9.8,57.3,19.6,57.3c18.7,0,18.7-42.1,37.3-42.1c9.5,0,9.5-36.9,19-36.9 c9.8,0,9.8-8.7,19.6-8.7c9.5,0,9.5-0.9,19-0.9c9.8,0,9.8,13.4,19.6,13.4s9.8-12.7,19.6-12.7c9.5,0,9.5,3.3,19,3.3 c9.8,0,9.8-4.4,19.6-4.4c9.5,0,9.5,80,19,80l0,0c-9.5,0-9.5-90.8-19-90.8c-9.8,0-9.8,6.6-19.6,6.6c-9.5,0-9.5-3.3-19-3.3 c-9.8,0-9.8,12.1-19.6,12.1s-9.8-14.7-19.6-14.7c-9.5,0-9.5,2.3-19,2.3c-9.8,0-9.8,7.7-19.6,7.7c-9.5,0-9.5,37.4-19,37.4 c-18.7,0-18.7,42.8-37.3,42.8c-9.8,0-9.8-61.6-19.6-61.6c-29.1,0-29.1-11-58.2-11c-9.5,0-9.5-29.8-19-29.8 c-9.8,0-9.8,29.5-19.6,29.5c-9.8,0-9.8-7-19.6-7c-9.5,0-9.5-2.3-19-2.3c-9.8,0-9.8-6.3-19.6-6.3c-9.5,0-9.5,5-19,5 c-9.8,0-9.8,30.9-19.6,30.9c-8.9,0-8.9,7.6-17.7,7.6c-9.8,0-9.8-42.4-19.6-42.4s-9.8,18.7-19.6,18.7c-9.5,0-9.5-48.4-19-48.4 c-9.8,0-9.8-1.2-19.6-1.2c-9.5,0-9.5-1.6-19-1.6c-9.8,0-9.8,41.4-19.6,41.4c-9.8,0-9.8,0.3-19.6,0.3c-9.5,0-9.5-28.4-19-28.4 c-9.8,0-9.8-13.1-19.6-13.1c-9.5,0-9.5,6.8-19,6.8c-9.8,0-9.8,19.1-19.6,19.1c-9.2,0-9.2,38.9-18.4,38.9 c-9.8,0-9.8-53.6-19.6-53.6c-9.8,0-9.8-24.3-19.6-24.3c-9.5,0-9.5,2.9-19,2.9c-9.8,0-9.8-2-19.6-2c-9.5,0-9.5,35.6-19,35.6 c-9.8,0-9.8,2.8-19.6,2.8c-9.8,0-9.8-42.5-19.6-42.5c-9.5,0-9.5,5.1-19,5.1c-9.8,0-9.8,1.5-19.6,1.5 c-19.3,0-19.3,14.4-38.6,14.4c-8.9,0-8.9,20.4-17.7,20.4c-19.6,0-19.6-38.3-39.2-38.3c-9.5,0-9.5-20.1-19-20.1 c-9.8,0-9.8,0.9-19.6,0.9c-9.5,0-9.5,26-19,26c-9.8,0-9.8,16.1-19.6,16.1c-9.8,0-9.8-29.6-19.6-29.6c-9.5,0-9.5-9.1-19-9.1 c-9.8,0-9.8,5-19.6,5c-9.5,0-9.5,20.6-19,20.6c-18.7,0-18.7,25.2-37.3,25.2c-9.8,0-9.8-16.4-19.6-16.4V548z"
  }), React.createElement("path", {
    id: "XMLID_1667_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,564.4c9.8,0,9.8-12.3,19.6-12.3c18.7,0,18.7,7.2,37.3,7.2 c9.5,0,9.5-24.1,19-24.1c9.8,0,9.8-16,19.6-16c9.5,0,9.5,14.4,19,14.4c9.8,0,9.8,28.6,19.6,28.6c9.8,0,9.8-9.4,19.6-9.4 c9.5,0,9.5-27.8,19-27.8c9.8,0,9.8,5.5,19.6,5.5c9.5,0,9.5,9.8,19,9.8c19.6,0,19.6,42.9,39.2,42.9c8.9,0,8.9-17.1,17.7-17.1 c19.3,0,19.3-8.3,38.6-8.3c9.8,0,9.8-12.7,19.6-12.7c9.5,0,9.5-2.1,19-2.1c9.8,0,9.8,38,19.6,38c9.8,0,9.8,5.5,19.6,5.5 c9.5,0,9.5-37.4,19-37.4c9.8,0,9.8-2.9,19.6-2.9c9.5,0,9.5-1.3,19-1.3c9.8,0,9.8,44,19.6,44c9.8,0,9.8,24.9,19.6,24.9 c9.2,0,9.2-19.8,18.4-19.8c9.8,0,9.8-10,19.6-10c9.5,0,9.5-26.5,19-26.5c9.8,0,9.8,5.7,19.6,5.7c9.5,0,9.5,64,19,64 c9.8,0,9.8-10.8,19.6-10.8c9.8,0,9.8-46,19.6-46c9.5,0,9.5,3.7,19,3.7c9.8,0,9.8,16.5,19.6,16.5c9.5,0,9.5,22.8,19,22.8 c9.8,0,9.8,21.1,19.6,21.1s9.8-9.1,19.6-9.1c8.9,0,8.9-7.7,17.7-7.7c9.8,0,9.8-10.3,19.6-10.3c9.5,0,9.5-5.1,19-5.1 c9.8,0,9.8-25.8,19.6-25.8c9.5,0,9.5,30.4,19,30.4c9.8,0,9.8,9.7,19.6,9.7c9.8,0,9.8-32.6,19.6-32.6c9.5,0,9.5-1.2,19-1.2 c29.1,0,29.1,91.6,58.2,91.6c9.8,0,9.8-1.4,19.6-1.4c18.7,0,18.7-39.7,37.3-39.7c9.5,0,9.5,0,19,0c9.8,0,9.8-32.2,19.6-32.2 c9.5,0,9.5-3.5,19-3.5c9.8,0,9.8,24.1,19.6,24.1s9.8-21,19.6-21c9.5,0,9.5-2.2,19-2.2c9.8,0,9.8,2.7,19.6,2.7 c9.5,0,9.5,19.3,19,19.3v-6.3c-9.5,0-9.5-19.3-19-19.3c-9.8,0-9.8-2.2-19.6-2.2c-9.5,0-9.5,3-19,3c-9.8,0-9.8,20.8-19.6,20.8 s-9.8-27-19.6-27c-9.5,0-9.5,5.7-19,5.7c-9.8,0-9.8,31.8-19.6,31.8c-9.5,0-9.5,6.2-19,6.2c-18.7,0-18.7,34.2-37.3,34.2 c-9.8,0-9.8,0.7-19.6,0.7c-29.1,0-29.1-93.6-58.2-93.6c-9.5,0-9.5,4.8-19,4.8c-9.8,0-9.8,32.5-19.6,32.5 c-9.8,0-9.8-9.1-19.6-9.1c-9.5,0-9.5-26.3-19-26.3c-9.8,0-9.8,20.9-19.6,20.9c-9.5,0-9.5,4.6-19,4.6c-9.8,0-9.8,11.2-19.6,11.2 c-8.9,0-8.9,7.8-17.7,7.8c-9.8,0-9.8,9.5-19.6,9.5s-9.8-20.7-19.6-20.7c-9.5,0-9.5-22.7-19-22.7c-9.8,0-9.8-16-19.6-16 c-9.5,0-9.5-3.3-19-3.3c-9.8,0-9.8,46.2-19.6,46.2c-9.8,0-9.8,9.9-19.6,9.9c-9.5,0-9.5-64.8-19-64.8c-9.8,0-9.8-6.1-19.6-6.1 c-9.5,0-9.5,27-19,27c-9.8,0-9.8,10-19.6,10c-9.2,0-9.2,19.6-18.4,19.6c-9.8,0-9.8-25.3-19.6-25.3c-9.8,0-9.8-43.5-19.6-43.5 c-9.5,0-9.5,1.1-19,1.1c-9.8,0-9.8,3.3-19.6,3.3c-9.5,0-9.5,36.7-19,36.7c-9.8,0-9.8-5.2-19.6-5.2c-9.8,0-9.8-37.5-19.6-37.5 c-9.5,0-9.5,1.8-19,1.8c-9.8,0-9.8,13-19.6,13c-19.3,0-19.3,7.8-38.6,7.8c-8.9,0-8.9,17.7-17.7,17.7 c-19.6,0-19.6-43.3-39.2-43.3c-9.5,0-9.5-10.4-19-10.4c-9.8,0-9.8-4.4-19.6-4.4c-9.5,0-9.5,27.6-19,27.6 c-9.8,0-9.8,9.4-19.6,9.4c-9.8,0-9.8-28.8-19.6-28.8c-9.5,0-9.5-14.6-19-14.6c-9.8,0-9.8,16.2-19.6,16.2 c-9.5,0-9.5,24.8-19,24.8c-18.7,0-18.7-8.2-37.3-8.2c-9.8,0-9.8,12.6-19.6,12.6V564.4z"
  }), React.createElement("path", {
    id: "XMLID_1666_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,452.1c9.8,0,9.8-19.6,19.6-19.6c18.7,0,18.7-52,37.3-52 c9.5,0,9.5,1.3,19,1.3c9.8,0,9.8,1.8,19.6,1.8c9.5,0,9.5,8.9,19,8.9c9.8,0,9.8,43.5,19.6,43.5c9.8,0,9.8-75.1,19.6-75.1 c9.5,0,9.5,24,19,24c9.8,0,9.8,5.2,19.6,5.2c9.5,0,9.5-0.1,19-0.1c19.6,0,19.6,4.9,39.2,4.9c8.9,0,8.9-7.3,17.7-7.3 c19.3,0,19.3-5.2,38.6-5.2c9.8,0,9.8,2.9,19.6,2.9c9.5,0,9.5,6.4,19,6.4c9.8,0,9.8,53.4,19.6,53.4c9.8,0,9.8-33.9,19.6-33.9 c9.5,0,9.5,18.9,19,18.9c9.8,0,9.8-4.1,19.6-4.1c9.5,0,9.5-4.5,19-4.5c9.8,0,9.8,44.5,19.6,44.5c9.8,0,9.8-5.8,19.6-5.8 c9.2,0,9.2-29.8,18.4-29.8c9.8,0,9.8-4.4,19.6-4.4c9.5,0,9.5,0.1,19,0.1c9.8,0,9.8,15.9,19.6,15.9c9.5,0,9.5,20.6,19,20.6 c9.8,0,9.8-115.2,19.6-115.2c9.8,0,9.8,93.4,19.6,93.4c9.5,0,9.5-5.3,19-5.3c9.8,0,9.8,4.7,19.6,4.7c9.5,0,9.5,15.2,19,15.2 c9.8,0,9.8,35.5,19.6,35.5S750,468,759.8,468c8.9,0,8.9-4.3,17.7-4.3c9.8,0,9.8-17.5,19.6-17.5c9.5,0,9.5,6.8,19,6.8 c9.8,0,9.8,18.5,19.6,18.5c9.5,0,9.5,4.3,19,4.3c9.8,0,9.8-61.4,19.6-61.4c9.8,0,9.8,42.1,19.6,42.1c9.5,0,9.5,7.6,19,7.6 c29.1,0,28.2,41,57.3,41c9.8,0,10.7-5.3,20.5-5.3c18.7,0,18.7-14.4,37.3-14.4c9.5,0,9.5-22,19-22c9.8,0,9.8-8.7,19.6-8.7 c9.5,0,9.5,2.1,19,2.1c9.8,0,9.8,23.3,19.6,23.3s9.8-7.2,19.6-7.2c9.5,0,9.5-2.5,19-2.5c9.8,0,9.8-10.4,19.6-10.4 c9.5,0,9.5,20.3,19,20.3v-51.5c-9.5,0-9.5-14.6-19-14.6c-9.8,0-9.8,13-19.6,13c-9.5,0-9.5-5.3-19-5.3c-9.8,0-9.8-4.1-19.6-4.1 s-9.8-9.3-19.6-9.3c-9.5,0-9.5,7.9-19,7.9c-9.8,0-9.8,3.3-19.6,3.3c-9.5,0-9.5,18.9-19,18.9c-18.7,0-18.7,3.6-37.3,3.6 c-9.8,0-9.8,29.2-19.6,29.2c-29.1,0-29.1-44.3-58.2-44.3c-9.5,0-9.5-15.1-19-15.1c-9.8,0-9.8-58.9-19.6-58.9 c-9.8,0-9.8,77.5-19.6,77.5c-9.5,0-9.5,4.4-19,4.4c-9.8,0-9.8-24.7-19.6-24.7c-9.5,0-9.5-7-19-7c-9.8,0-9.8,2.3-19.6,2.3 c-8.9,0-8.9,10.8-17.7,10.8c-9.8,0-9.8,25.3-19.6,25.3s-9.8-28.3-19.6-28.3c-9.5,0-9.5-13.8-19-13.8c-9.8,0-9.8-0.5-19.6-0.5 c-9.5,0-9.5,0.1-19,0.1c-9.8,0-9.8-111.1-19.6-111.1c-9.8,0-9.8,132.1-19.6,132.1c-9.5,0-9.5-14.1-19-14.1 c-9.8,0-9.8-17.7-19.6-17.7c-9.5,0-9.5-0.6-19-0.6c-9.8,0-9.8-6.2-19.6-6.2c-9.2,0-9.2,30-18.4,30c-9.8,0-9.8,14.5-19.6,14.5 c-9.8,0-9.8-38.7-19.6-38.7c-9.5,0-9.5,3.9-19,3.9c-9.8,0-9.8-5.1-19.6-5.1c-9.5,0-9.5-28.5-19-28.5c-9.8,0-9.8,47.6-19.6,47.6 c-9.8,0-9.8-44.7-19.6-44.7c-9.5,0-9.5-10.7-19-10.7c-9.8,0-9.8-3-19.6-3c-19.3,0-19.3-4.1-38.6-4.1c-8.9,0-8.9,8.9-17.7,8.9 c-19.6,0-19.6,3.2-39.2,3.2c-9.5,0-9.5,3.2-19,3.2c-9.8,0-9.8-9.7-19.6-9.7c-9.5,0-9.5-37-19-37c-9.8,0-9.8,87.7-19.6,87.7 c-9.8,0-9.8-36.5-19.6-36.5c-9.5,0-9.5-10.9-19-10.9c-9.8,0-9.8-3.7-19.6-3.7c-9.5,0-9.5-10-19-10c-18.7,0-18.7,56.1-37.3,56.1 c-9.8,0-9.8,24.4-19.6,24.4V452.1z"
  }), React.createElement("path", {
    id: "XMLID_1665_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,298.3c9.8,0,9.8-14.7,19.6-14.7c18.7,0,18.7-13.4,37.3-13.4 c9.5,0,9.5,10,19,10c9.8,0,9.8,10.2,19.6,10.2c9.5,0,9.5,9.9,19,9.9c9.8,0,9.8-3.8,19.6-3.8c9.8,0,9.8,13.4,19.6,13.4 c9.5,0,9.5-5.8,19-5.8c9.8,0,9.8-2.6,19.6-2.6c9.5,0,9.5-2.4,19-2.4c19.6,0,19.6-13.1,39.2-13.1c8.9,0,8.9-15.1,17.7-15.1 c19.3,0,19.3,6.3,38.6,6.3c9.8,0,9.8,5.2,19.6,5.2c9.5,0,9.5,12.7,19,12.7c9.8,0,9.8-20.7,19.6-20.7c9.8,0,9.8,17.6,19.6,17.6 c9.5,0,9.5-3.9,19-3.9c9.8,0,9.8,1.7,19.6,1.7c9.5,0,9.5,4.2,19,4.2c9.8,0,9.8,0.1,19.6,0.1c9.8,0,9.8-33.9,19.6-33.9 c9.2,0,9.2-6.6,18.4-6.6c9.8,0,9.8,8.4,19.6,8.4c9.5,0,9.5,6.6,19,6.6c9.8,0,9.8,6.4,19.6,6.4c9.5,0,9.5-9.4,19-9.4 c9.8,0,9.8,21.1,19.6,21.1c9.8,0,9.8,7.6,19.6,7.6c9.5,0,9.5-7.4,19-7.4c9.8,0,9.8-2.9,19.6-2.9c9.5,0,9.5-11.9,19-11.9 c9.8,0,9.8-12.3,19.6-12.3s9.8,0.3,19.6,0.3c8.9,0,8.9-6.6,17.7-6.6c9.8,0,9.8-10.1,19.6-10.1c9.5,0,9.5,12.5,19,12.5 c9.8,0,9.8,30.4,19.6,30.4c9.5,0,9.5-29.3,19-29.3c9.8,0,9.8,1.7,19.6,1.7c9.8,0,9.8,18.5,19.6,18.5c9.5,0,9.5-5.2,19-5.2 c29.1,0,29.1-15.9,58.2-15.9c9.8,0,9.8-39.6,19.6-39.6c18.7,0,18.7,26.3,37.3,26.3c9.5,0,9.5-21.2,19-21.2 c9.8,0,9.8,25.3,19.6,25.3c9.5,0,9.5-12.6,19-12.6c9.8,0,9.8,1.6,19.6,1.6s9.8,22.4,19.6,22.4c9.5,0,9.5-6.2,19-6.2 c9.8,0,9.8-1.4,19.6-1.4c9.5,0,9.5-19.6,19-19.6V108.4c-9.5,0-9.5,24.9-19,24.9c-9.8,0-9.8-1.3-19.6-1.3c-9.5,0-9.5,1.9-19,1.9 c-9.8,0-9.8-20-19.6-20s-9.8,13.3-19.6,13.3c-9.5,0-9.5,10.8-19,10.8c-9.8,0-9.8-26.7-19.6-26.7c-9.5,0-9.5,14.1-19,14.1 c-18.7,0-18.7-59-37.3-59c-9.8,0-9.8-0.1-19.6-0.1c-29.1,0-29.1,72.3-58.2,72.3c-9.5,0-9.5,19.9-19,19.9 c-9.8,0-9.8-35.7-19.6-35.7c-9.8,0-9.8,7.6-19.6,7.6c-9.5,0-9.5,52-19,52c-9.8,0-9.8-49.7-19.6-49.7c-9.5,0-9.5-1.4-19-1.4 c-9.8,0-9.8-7.8-19.6-7.8c-8.9,0-8.9-7.6-17.7-7.6c-9.8,0-9.8-3.8-19.6-3.8s-9.8,22.8-19.6,22.8c-9.5,0-9.5,27-19,27 c-9.8,0-9.8,17.3-19.6,17.3c-9.5,0-9.5,4.9-19,4.9c-9.8,0-9.8-38.6-19.6-38.6c-9.8,0-9.8-16.5-19.6-16.5c-9.5,0-9.5,41-19,41 c-9.8,0-9.8,7.9-19.6,7.9c-9.5,0-9.5-9.8-19-9.8c-9.8,0-9.8-9.1-19.6-9.1c-9.2,0-9.2-30.5-18.4-30.5c-9.8,0-9.8,24.8-19.6,24.8 c-9.8,0-9.8,39.9-19.6,39.9c-9.5,0-9.5-1.1-19-1.1c-9.8,0-9.8,4.6-19.6,4.6c-9.5,0-9.5-38.2-19-38.2c-9.8,0-9.8,1.7-19.6,1.7 c-9.8,0-9.8,42.1-19.6,42.1c-9.5,0-9.5-9.9-19-9.9c-9.8,0-9.8-1.7-19.6-1.7c-19.3,0-19.3-8.8-38.6-8.8 c-8.9,0-8.9-11.8-17.7-11.8c-19.6,0-19.6,33.2-39.2,33.2c-9.5,0-9.5,10-19,10c-9.8,0-9.8,12.3-19.6,12.3c-9.5,0-9.5-32-19-32 c-9.8,0-9.8-6.3-19.6-6.3c-9.8,0-9.8,22.6-19.6,22.6c-9.5,0-9.5,5-19,5c-9.8,0-9.8-5.4-19.6-5.4c-9.5,0-9.5-15.2-19-15.2 c-18.7,0-18.7-8.7-37.3-8.7c-9.8,0-9.8-0.4-19.6-0.4V298.3z"
  }), React.createElement("path", {
    id: "XMLID_1664_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,532.3c9.8,0,9.8-11.2,19.6-11.2c18.7,0,18.7-19.9,37.3-19.9 c9.5,0,9.5-10,19-10c9.8,0,9.8-29,19.6-29c9.5,0,9.5,5.4,19,5.4c9.8,0,9.8,41.9,19.6,41.9c9.8,0,9.8-9.6,19.6-9.6 c9.5,0,9.5-31.2,19-31.2c9.8,0,9.8,1.3,19.6,1.3c9.5,0,9.5-5.1,19-5.1c19.6,0,19.6,80.3,39.2,80.3c8.9,0,8.9-26,17.7-26 c19.3,0,19.3-6.1,38.6-6.1c9.8,0,9.8-42.5,19.6-42.5c9.5,0,9.5,18.8,19,18.8c9.8,0,9.8,40.1,19.6,40.1c9.8,0,9.8-5.1,19.6-5.1 c9.5,0,9.5-30.9,19-30.9c9.8,0,9.8-3.6,19.6-3.6c9.5,0,9.5-17.6,19-17.6c9.8,0,9.8,74.8,19.6,74.8c9.8,0,9.8,20.4,19.6,20.4 c9.2,0,9.2-30.3,18.4-30.3c9.8,0,9.8-4.8,19.6-4.8c9.5,0,9.5-7,19-7c9.8,0,9.8-9.8,19.6-9.8c9.5,0,9.5,50.1,19,50.1 c9.8,0,9.8-19.3,19.6-19.3c9.8,0,9.8-41.5,19.6-41.5c9.5,0,9.5,22.4,19,22.4c9.8,0,9.8,11.4,19.6,11.4c9.5,0,9.5,26.8,19,26.8 c9.8,0,9.8,27.1,19.6,27.1s9.8-12.3,19.6-12.3c8.9,0,8.9-6.9,17.7-6.9c9.8,0,9.8-14.6,19.6-14.6c9.5,0,9.5,8.4,19,8.4 c9.8,0,9.8-27.3,19.6-27.3c9.5,0,9.5,35.9,19,35.9c9.8,0,9.8-16.2,19.6-16.2c9.8,0,9.8-40.4,19.6-40.4c9.5,0,9.5,43.6,19,43.6 c29.1,0,29.1,73.8,58.2,73.8c9.8,0,9.8-2.9,19.6-2.9c18.7,0,18.7-32.3,37.3-32.3c9.5,0,9.5-25.9,19-25.9 c9.8,0,9.8-34.4,19.6-34.4c9.5,0,9.5,24.4,19,24.4c9.8,0,9.8,14.7,19.6,14.7s9.8-51.5,19.6-51.5c9.5,0,9.5,42.7,19,42.7 c9.8,0,9.8-6.6,19.6-6.6c9.5,0,9.5,39.1,19,39.1v-11.1c-9.5,0-9.5-40.1-19-40.1c-9.8,0-9.8,7.7-19.6,7.7 c-9.5,0-9.5-44.4-19-44.4c-9.8,0-9.8,53.1-19.6,53.1s-9.8-14.1-19.6-14.1c-9.5,0-9.5-25.9-19-25.9c-9.8,0-9.8,34.8-19.6,34.8 c-9.5,0-9.5,26.3-19,26.3c-18.7,0-18.7,31.8-37.3,31.8c-9.8,0-9.8,3.2-19.6,3.2c-29.1,0-29.1-74.2-58.2-74.2 c-9.5,0-9.5-42.8-19-42.8c-9.8,0-9.8,39.6-19.6,39.6c-9.8,0-9.8,17.8-19.6,17.8c-9.5,0-9.5-36.8-19-36.8 c-9.8,0-9.8,25.7-19.6,25.7c-9.5,0-9.5-7.9-19-7.9c-9.8,0-9.8,14.6-19.6,14.6c-8.9,0-8.9,8.3-17.7,8.3 c-9.8,0-9.8,13.3-19.6,13.3s-9.8-27.9-19.6-27.9c-9.5,0-9.5-27.6-19-27.6c-9.8,0-9.8-10.2-19.6-10.2c-9.5,0-9.5-22.4-19-22.4 c-9.8,0-9.8,41.2-19.6,41.2c-9.8,0-9.8,18.1-19.6,18.1c-9.5,0-9.5-49.5-19-49.5c-9.8,0-9.8,9.2-19.6,9.2c-9.5,0-9.5,6.9-19,6.9 c-9.8,0-9.8,4.5-19.6,4.5c-9.2,0-9.2,30-18.4,30c-9.8,0-9.8-18.6-19.6-18.6c-9.8,0-9.8-77.2-19.6-77.2c-9.5,0-9.5,19.2-19,19.2 c-9.8,0-9.8,2.5-19.6,2.5c-9.5,0-9.5,31-19,31c-9.8,0-9.8,5.1-19.6,5.1c-9.8,0-9.8-40-19.6-40c-9.5,0-9.5-20.6-19-20.6 c-9.8,0-9.8,44.1-19.6,44.1c-19.3,0-19.3,5.3-38.6,5.3c-8.9,0-8.9,28.6-17.7,28.6c-19.6,0-19.6-83.9-39.2-83.9 c-9.5,0-9.5,8.6-19,8.6c-9.8,0-9.8-0.5-19.6-0.5c-9.5,0-9.5,31.1-19,31.1c-9.8,0-9.8,8.8-19.6,8.8c-9.8,0-9.8-42.9-19.6-42.9 c-9.5,0-9.5-5.5-19-5.5c-9.8,0-9.8,31.2-19.6,31.2c-9.5,0-9.5,8.2-19,8.2c-18.7,0-18.7,20.8-37.3,20.8 c-9.8,0-9.8,13.5-19.6,13.5V532.3z"
  }), React.createElement("path", {
    id: "XMLID_90_",
    style: {
      opacity: 0.75,
      fill: "#FF9800"
    },
    d: "M980.9,530.7c18.7-0.1,28.6-21,47.3-21c9.5,0,9.5-20.4,19-20.4 c9.8,0,9.8-12.5,19.6-12.5c9.5,0,9.5,24.3,19,24.3c9.8,0,9.8,22.3,19.6,22.3s9.8-9.2,19.6-9.2c9.5,0,9.5-22.5,19-22.5 c9.8,0,9.8-9.8,19.6-9.8c9.5,0,9.5,51.6,19,51.6V512c-9.5,0-9.5-50.3-19-50.3c-9.8,0-9.8,10.4-19.6,10.4 c-9.5,0-9.5,25.3-19,25.3c-9.8,0-9.8,6.1-19.6,6.1s-9.8-21.2-19.6-21.2c-9.5,0-9.5-25.9-19-25.9c-9.8,0-9.8,8.7-19.6,8.7 c-9.5,0-9.5,22-19,22c-18.7,0-20.9,14.5-37.3,14.4c-10.8-0.1-8.1,5.6-20.8,5.2c-23.5-0.8-57-18.9-57-18.9 c-9.5,0-9.5-11.6-19-11.6c-9.8,0-9.8,21-19.6,21c-9.8,0-9.8,1.5-19.6,1.5c-9.5,0-9.5-25.5-19-25.5c-9.8,0-9.8-18.5-19.6-18.5 c-9.5,0-9.5,57.3-19,57.3c-9.8,0-9.8-23.4-19.6-23.4c-8.9,0-8.9-18.9-17.7-18.9c-9.8,0-9.8,182.2-19.6,182.2 s-9.8-170.4-19.6-170.4c-9.5,0-9.5-39.7-19-39.7c-9.8,0-9.8,14.5-19.6,14.5c-9.5,0-9.5,7.6-19,7.6c-9.8,0-9.8,22.3-19.6,22.3 c-9.8,0-9.8,2.5-19.6,2.5c-9.5,0-9.5-22.1-19-22.1c-9.8,0-9.8-38.9-19.6-38.9c-9.5,0-9.5-0.1-19-0.1c-9.8,0-9.8,26-19.6,26 c-9.2,0-9.2,8.2-18.4,8.2c-9.8,0-9.8,148.7-19.6,148.7c-9.8,0-9.8-187.5-19.6-187.5c-9.5,0-9.5,4.5-19,4.5 c-9.8,0-9.8,4.1-19.6,4.1c-9.5,0-9.5,47.9-19,47.9c-9.8,0-9.8-13.3-19.6-13.3c-9.8,0-9.8-40.3-19.6-40.3c-9.5,0-9.5-7.3-19-7.3 c-9.8,0-9.8-1.2-19.6-1.2c-19.3,0-19.3,2.1-38.6,2.1c-8.9,0-8.9,18.6-17.7,18.6c-19.6,0-19.6-25-39.2-25c-9.5,0-9.5-1.1-19-1.1 c-9.8,0-9.8,1.3-19.6,1.3c-9.5,0-9.5,48-19,48c-9.8,0-9.8-7.1-19.6-7.1c-9.8,0-9.8-14.5-19.6-14.5c-9.5,0-9.5-23.4-19-23.4 c-9.8,0-9.8-1.2-19.6-1.2c-9.5,0-9.5,4.7-19,4.7c-18.7,0-18.7,14.3-37.3,14.3c-9.8,0-9.8,144.5-19.6,144.5 c9.8,0,9.8-124.6,19.6-124.6c18.7,0,18.7-13.6,37.3-13.6c9.5,0,9.5-5.5,19-5.5c9.8,0,9.8-2.7,19.6-2.7c9.5,0,9.5,21.9,19,21.9 c9.8,0,9.8,14.5,19.6,14.5c9.8,0,9.8,5.5,19.6,5.5c9.5,0,9.5-44.8,19-44.8c9.8,0,9.8-0.8,19.6-0.8c9.5,0,9.5,2.7,19,2.7 c19.6,0,19.6,29.3,39.2,29.3c8.9,0,8.9-24,17.7-24c19.3,0,19.3,0.8,38.6,0.8c9.8,0,9.8-0.6,19.6-0.6c9.5,0,9.5,5.5,19,5.5 c9.8,0,9.8,41.6,19.6,41.6c9.8,0,9.8,11.1,19.6,11.1c9.5,0,9.5-46.2,19-46.2c9.8,0,9.8-3.4,19.6-3.4c9.5,0,9.5-3.4,19-3.4 c9.8,0,9.8,168.9,19.6,168.9c9.8,0,9.8-124.5,19.6-124.5c9.2,0,9.2-14.8,18.4-14.8c9.8,0,9.8-21.1,19.6-21.1 c9.5,0,9.5-2.2,19-2.2c9.8,0,9.8,37.6,19.6,37.6c9.5,0,9.5,20.1,19,20.1c9.8,0,9.8-1.2,19.6-1.2c9.8,0,9.8-25.8,19.6-25.8 c9.5,0,9.5-5.7,19-5.7c9.8,0,9.8-11.9,19.6-11.9c9.5,0,9.5,39.1,19,39.1c9.8,0,9.8,151.6,19.6,151.6s9.8-155.6,19.6-155.6 c8.9,0,8.9,11.5,17.7,11.5c9.8,0,9.8,22.1,19.6,22.1c9.5,0,9.5-50,19-50c9.8,0,9.8,11.9,19.6,11.9c9.5,0,9.5,24.2,19,24.2 c9.8,0,9.8,0.2,19.6,0.2c9.8,0,9.8-24.8,19.6-24.8c9.5,0,9.5,15.3,19,15.2C937,506.6,935.2,530.9,980.9,530.7z"
  }), React.createElement("path", {
    id: "XMLID_1662_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,559.1c9.8,0,9.8,12.8,19.6,12.8c18.7,0,18.7-8.2,37.3-8.2 c9.5,0,9.5-23.7,19-23.7c9.8,0,9.8-15.4,19.6-15.4c9.5,0,9.5,31,19,31c9.8,0,9.8-16.8,19.6-16.8c9.8,0,9.8,3.2,19.6,3.2 c9.5,0,9.5-22,19-22c9.8,0,9.8,15.2,19.6,15.2c9.5,0,9.5,23.3,19,23.3c19.6,0,19.6,14.3,39.2,14.3c8.9,0,8.9-12.5,17.7-12.5 c19.3,0,19.3,2.3,38.6,2.3c9.8,0,9.8-12.2,19.6-12.2c9.5,0,9.5,9.3,19,9.3c9.8,0,9.8,2.3,19.6,2.3c9.8,0,9.8,18.4,19.6,18.4 c9.5,0,9.5-42.3,19-42.3c9.8,0,9.8,18.8,19.6,18.8c9.5,0,9.5-6.9,19-6.9c9.8,0,9.8,44.6,19.6,44.6c9.8,0,9.8,29.4,19.6,29.4 c9.2,0,9.2-41,18.4-41c9.8,0,9.8-4.5,19.6-4.5c9.5,0,9.5-9.4,19-9.4c9.8,0,9.8,26.5,19.6,26.5c9.5,0,9.5,2.3,19,2.3 c9.8,0,9.8-20.8,19.6-20.8c9.8,0,9.8-26.7,19.6-26.7c9.5,0,9.5,14,19,14c9.8,0,9.8,9.9,19.6,9.9c9.5,0,9.5,52.6,19,52.6 c9.8,0,9.8,2.2,19.6,2.2s9.8,1.9,19.6,1.9c8.9,0,8.9-7.4,17.7-7.4c9.8,0,9.8-3.5,19.6-3.5c9.5,0,9.5,4.2,19,4.2 c9.8,0,9.8-44.4,19.6-44.4c9.5,0,9.5,47.2,19,47.2c9.8,0,9.8-24.1,19.6-24.1c9.8,0,9.8-32,19.6-32c9.5,0,9.5,27.7,19,27.7 c29.1,0,29.1,81.8,58.2,81.8c9.8,0,9.8,9.7,19.6,9.7c18.7,0,18.7-53.4,37.3-53.4c9.5,0,9.5,8.3,19,8.3c9.8,0,9.8-17.6,19.6-17.6 c9.5,0,9.5-22.4,19-22.4c9.8,0,9.8,2.3,19.6,2.3s9.8-0.1,19.6-0.1c9.5,0,9.5,19.3,19,19.3c9.8,0,9.8-2.4,19.6-2.4 c9.5,0,9.5,20.9,19,20.9v-3.4c-9.5,0-9.5-20.8-19-20.8c-9.8,0-9.8,2.6-19.6,2.6c-9.5,0-9.5-20.8-19-20.8 c-9.8,0-9.8-1.5-19.6-1.5s-9.8-1.7-19.6-1.7c-9.5,0-9.5,26.2-19,26.2c-9.8,0-9.8,15.8-19.6,15.8c-9.5,0-9.5-4.7-19-4.7 c-18.7,0-18.7,50-37.3,50c-9.8,0-9.8-10.6-19.6-10.6c-29.1,0-29.1-81.9-58.2-81.9c-9.5,0-9.5-30.1-19-30.1 c-9.8,0-9.8,31-19.6,31c-9.8,0-9.8,28.8-19.6,28.8c-9.5,0-9.5-44.1-19-44.1c-9.8,0-9.8,41.4-19.6,41.4c-9.5,0-9.5-5.8-19-5.8 c-9.8,0-9.8,4-19.6,4c-8.9,0-8.9,7.7-17.7,7.7c-9.8,0-9.8-2.9-19.6-2.9s-9.8,0.3-19.6,0.3c-9.5,0-9.5-55.2-19-55.2 c-9.8,0-9.8-8.6-19.6-8.6c-9.5,0-9.5-15.3-19-15.3c-9.8,0-9.8,24.2-19.6,24.2c-9.8,0-9.8,19.9-19.6,19.9c-9.5,0-9.5,4.6-19,4.6 c-9.8,0-9.8-29-19.6-29c-9.5,0-9.5,9.4-19,9.4c-9.8,0-9.8,4.4-19.6,4.4c-9.2,0-9.2,41.8-18.4,41.8c-9.8,0-9.8-30.1-19.6-30.1 c-9.8,0-9.8-44-19.6-44c-9.5,0-9.5,6.7-19,6.7c-9.8,0-9.8-20.5-19.6-20.5c-9.5,0-9.5,42.4-19,42.4c-9.8,0-9.8-19.9-19.6-19.9 c-9.8,0-9.8,2.3-19.6,2.3c-9.5,0-9.5-10.9-19-10.9c-9.8,0-9.8,12.7-19.6,12.7c-19.3,0-19.3-3.2-38.6-3.2 c-8.9,0-8.9,13.1-17.7,13.1c-19.6,0-19.6-12.7-39.2-12.7c-9.5,0-9.5-24.5-19-24.5c-9.8,0-9.8-15.6-19.6-15.6 c-9.5,0-9.5,21-19,21c-9.8,0-9.8-4.7-19.6-4.7c-9.8,0-9.8,20.3-19.6,20.3c-9.5,0-9.5-32.3-19-32.3c-9.8,0-9.8,16-19.6,16 c-9.5,0-9.5,24.1-19,24.1c-18.7,0-18.7,8.2-37.3,8.2c-9.8,0-9.8-13.8-19.6-13.8V559.1z"
  }), React.createElement("path", {
    id: "XMLID_1661_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,483.9c9.8,0,9.8-14.8,19.6-14.8c18.7,0,18.7-10.6,37.3-10.6 c9.5,0,9.5-8.2,19-8.2c9.8,0,9.8-1.7,19.6-1.7c9.5,0,9.5-10.5,19-10.5c9.8,0,9.8,45.2,19.6,45.2c9.8,0,9.8,4.9,19.6,4.9 c9.5,0,9.5-44,19-44c9.8,0,9.8-0.1,19.6-0.1c9.5,0,9.5,4.8,19,4.8c19.6,0,19.6,43,39.2,43c8.9,0,8.9-37.6,17.7-37.6 c19.3,0,19.3-0.3,38.6-0.3c9.8,0,9.8,0.9,19.6,0.9c9.5,0,9.5,20.6,19,20.6c9.8,0,9.8,40,19.6,40c9.8,0,9.8-5.1,19.6-5.1 c9.5,0,9.5-31,19-31c9.8,0,9.8-2.5,19.6-2.5c9.5,0,9.5-19.2,19-19.2c9.8,0,9.8,77.2,19.6,77.2c9.8,0,9.8,4.4,19.6,4.4 c9.2,0,9.2-15.8,18.4-15.8c9.8,0,9.8-35.4,19.6-35.4c9.5,0,9.5-5.3,19-5.3c9.8,0,9.8,20.2,19.6,20.2c9.5,0,9.5,35.9,19,35.9 c9.8,0,9.8-19.2,19.6-19.2c9.8,0,9.8-26.5,19.6-26.5c9.5,0,9.5,22.4,19,22.4c9.8,0,9.8-4.6,19.6-4.6c9.5,0,9.5,42.4,19,42.4 c9.8,0,9.8,15,19.6,15s9.8-0.4,19.6-0.4c8.9,0,8.9-8.3,17.7-8.3c9.8,0,9.8-14.6,19.6-14.6c9.5,0,9.5-7.3,19-7.3 c9.8,0,9.8-10.4,19.6-10.4c9.5,0,9.5,36.8,19,36.8c9.8,0,9.8-17.8,19.6-17.8c9.8,0,9.8-39.6,19.6-39.6c9.5,0,9.5,14.9,19,14.9 c29.1,0,29.1,102.1,58.2,102.1c9.8,0,9.8-17.9,19.6-17.9c18.7,0,18.7-17.1,37.3-17.1c9.5,0,9.5-42.6,19-42.6 c9.8,0,9.8-32.3,19.6-32.3c9.5,0,9.5,39.6,19,39.6c9.8,0,9.8,14.1,19.6,14.1s9.8-24.6,19.6-24.6c9.5,0,9.5,15.9,19,15.9 c9.8,0,9.8-7.7,19.6-7.7c9.5,0,9.5,40.1,19,40.1v-13.2c-9.5,0-9.5-40.2-19-40.2c-9.8,0-9.8,8.1-19.6,8.1 c-9.5,0-9.5-15.6-19-15.6c-9.8,0-9.8,25.2-19.6,25.2s-9.8-14.7-19.6-14.7c-9.5,0-9.5-42.2-19-42.2c-9.8,0-9.8,32.2-19.6,32.2 c-9.5,0-9.5,43.1-19,43.1c-18.7,0-18.7,18.1-37.3,18.1c-9.8,0-9.8,18.7-19.6,18.7c-29.1,0-29.1-102-58.2-102 c-9.5,0-9.5-15.2-19-15.2c-9.8,0-9.8,39.9-19.6,39.9c-9.8,0-9.8,18.9-19.6,18.9c-9.5,0-9.5-39.2-19-39.2 c-9.8,0-9.8,9.6-19.6,9.6c-9.5,0-9.5,9.2-19,9.2c-9.8,0-9.8,13.5-19.6,13.5c-8.9,0-8.9,10-17.7,10c-9.8,0-9.8,1.7-19.6,1.7 s-9.8-17.8-19.6-17.8c-9.5,0-9.5-42.4-19-42.4c-9.8,0-9.8,6.5-19.6,6.5c-9.5,0-9.5-22.7-19-22.7c-9.8,0-9.8,25.8-19.6,25.8 c-9.8,0-9.8,19.1-19.6,19.1c-9.5,0-9.5-38-19-38c-9.8,0-9.8-18.7-19.6-18.7c-9.5,0-9.5,3.5-19,3.5c-9.8,0-9.8,35.9-19.6,35.9 c-9.2,0-9.2,16.9-18.4,16.9c-9.8,0-9.8-2.9-19.6-2.9c-9.8,0-9.8-78.6-19.6-78.6c-9.5,0-9.5,19.7-19,19.7 c-9.8,0-9.8,2.7-19.6,2.7c-9.5,0-9.5,30.7-19,30.7c-9.8,0-9.8,5.1-19.6,5.1c-9.8,0-9.8-40.8-19.6-40.8c-9.5,0-9.5-22.4-19-22.4 c-9.8,0-9.8,0.6-19.6,0.6c-19.3,0-19.3-0.8-38.6-0.8c-8.9,0-8.9,40.1-17.7,40.1c-19.6,0-19.6-45.5-39.2-45.5 c-9.5,0-9.5-2.7-19-2.7c-9.8,0-9.8,0.8-19.6,0.8c-9.5,0-9.5,44.8-19,44.8c-9.8,0-9.8-5.5-19.6-5.5c-9.8,0-9.8-48.4-19.6-48.4 c-9.5,0-9.5,12-19,12c-9.8,0-9.8,2.7-19.6,2.7c-9.5,0-9.5,5.5-19,5.5c-18.7,0-18.7,13.6-37.3,13.6c-9.8,0-9.8,15.5-19.6,15.5 V483.9z"
  }), React.createElement("path", {
    id: "XMLID_1660_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,497.4c9.8,0,9.8-1.7,19.6-1.7c18.7,0,18.7,17.4,37.3,17.4 c9.5,0,9.5-10.9,19-10.9c9.8,0,9.8-15.9,19.6-15.9c9.5,0,9.5-5.9,19-5.9c9.8,0,9.8-27.8,19.6-27.8c9.8,0,9.8,7.1,19.6,7.1 c9.5,0,9.5-2.6,19-2.6c9.8,0,9.8,0.5,19.6,0.5c9.5,0,9.5,33,19,33c19.6,0,19.6-13.9,39.2-13.9c8.9,0,8.9,27.6,17.7,27.6 c19.3,0,19.3-5.3,38.6-5.3c9.8,0,9.8-13.6,19.6-13.6c9.5,0,9.5-26.3,19-26.3c9.8,0,9.8,5.7,19.6,5.7c9.8,0,9.8,13.3,19.6,13.3 c9.5,0,9.5-13.9,19-13.9c9.8,0,9.8-2.7,19.6-2.7c9.5,0,9.5,25.2,19,25.2c9.8,0,9.8,17.7,19.6,17.7c9.8,0,9.8,2.3,19.6,2.3 c9.2,0,9.2-17.7,18.4-17.7c9.8,0,9.8-18.4,19.6-18.4c9.5,0,9.5-3.5,19-3.5c9.8,0,9.8-2,19.6-2c9.5,0,9.5,22.1,19,22.1 c9.8,0,9.8-2.5,19.6-2.5c9.8,0,9.8-22.3,19.6-22.3c9.5,0,9.5-7.6,19-7.6c9.8,0,9.8,24.3,19.6,24.3c9.5,0,9.5,58.4,19,58.4 c9.8,0,9.8,1.1,19.6,1.1s9.8-21,19.6-21c8.9,0,8.9-30.6,17.7-30.6c9.8,0,9.8-18.6,19.6-18.6c9.5,0,9.5,34.8,19,34.8 c9.8,0,9.8,8.1,19.6,8.1c9.5,0,9.5-14,19-14c9.8,0,9.8-1.5,19.6-1.5c9.8,0,9.8-21,19.6-21c9.5,0,9.5,11.6,19,11.6 c29.1,0,29.1,88.9,58.2,88.9c9.8,0,9.8-21.4,19.6-21.4c18.7,0,18.7-20.3,37.3-20.3c9.5,0,9.5-4.4,19-4.4 c9.8,0,9.8-32.2,19.6-32.2c9.5,0,9.5-16.1,19-16.1c9.8,0,9.8,21.2,19.6,21.2s9.8-6.1,19.6-6.1c9.5,0,9.5,16.2,19,16.2 c9.8,0,9.8,6.8,19.6,6.8c9.5,0,9.5,57.3,19,57.3v-18.6c-9.5,0-9.5-54.6-19-54.6c-9.8,0-9.8-9.6-19.6-9.6 c-9.5,0-9.5-18.7-19-18.7c-9.8,0-9.8,7.2-19.6,7.2s-9.8-23.3-19.6-23.3c-9.5,0-9.5,19.9-19,19.9c-9.8,0-9.8,32.8-19.6,32.8 c-9.5,0-9.5,0.2-19,0.2c-18.7,0-18.7,21.3-37.3,21.3c-9.8,0-9.8,24.2-19.6,24.2c-29.1,0-29.1-91.1-58.2-91.1 c-9.5,0-9.5-7.6-19-7.6c-9.8,0-9.8,18.2-19.6,18.2c-9.8,0-9.8,1.1-19.6,1.1c-9.5,0-9.5,16-19,16c-9.8,0-9.8-11.9-19.6-11.9 c-9.5,0-9.5-33.7-19-33.7c-9.8,0-9.8,17.5-19.6,17.5c-8.9,0-8.9,32.5-17.7,32.5c-9.8,0-9.8,19.6-19.6,19.6s-9.8,4.8-19.6,4.8 c-9.5,0-9.5-59.5-19-59.5c-9.8,0-9.8-25.6-19.6-25.6c-9.5,0-9.5,5.3-19,5.3c-9.8,0-9.8,21.6-19.6,21.6c-9.8,0-9.8,0.2-19.6,0.2 c-9.5,0-9.5-20.6-19-20.6c-9.8,0-9.8,6-19.6,6c-9.5,0-9.5,2.2-19,2.2c-9.8,0-9.8,21.1-19.6,21.1c-9.2,0-9.2,14.8-18.4,14.8 c-9.8,0-9.8,1.8-19.6,1.8c-9.8,0-9.8-15.7-19.6-15.7c-9.5,0-9.5-27.1-19-27.1c-9.8,0-9.8,3.4-19.6,3.4c-9.5,0-9.5,12.1-19,12.1 c-9.8,0-9.8-15.6-19.6-15.6c-9.8,0-9.8-3-19.6-3c-9.5,0-9.5,28.4-19,28.4c-9.8,0-9.8,13.5-19.6,13.5c-19.3,0-19.3,4.5-38.6,4.5 c-8.9,0-8.9-28.1-17.7-28.1c-19.6,0-19.6,17.9-39.2,17.9c-9.5,0-9.5-34.2-19-34.2c-9.8,0-9.8,0.1-19.6,0.1 c-9.5,0-9.5,0.2-19,0.2c-9.8,0-9.8-8.4-19.6-8.4c-9.8,0-9.8,31.5-19.6,31.5c-9.5,0-9.5,7.1-19,7.1c-9.8,0-9.8,16.5-19.6,16.5 c-9.5,0-9.5,10-19,10c-18.7,0-18.7-18.8-37.3-18.8c-9.8,0-9.8,1.4-19.6,1.4V497.4z"
  }), React.createElement("path", {
    id: "XMLID_1659_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,569.4c9.8,0,9.8-11.8,19.6-11.8c18.7,0,18.7-12.9,37.3-12.9 c9.5,0,9.5-14.8,19-14.8c9.8,0,9.8-0.1,19.6-0.1c9.5,0,9.5,13.4,19,13.4c9.8,0,9.8,23.8,19.6,23.8c9.8,0,9.8-9.5,19.6-9.5 c9.5,0,9.5-42.5,19-42.5c9.8,0,9.8,9.5,19.6,9.5c9.5,0,9.5,20.9,19,20.9c19.6,0,19.6,32.8,39.2,32.8c8.9,0,8.9-6.5,17.7-6.5 c19.3,0,19.3-24.8,38.6-24.8c9.8,0,9.8,8.7,19.6,8.7c9.5,0,9.5-7.6,19-7.6c9.8,0,9.8,48.7,19.6,48.7c9.8,0,9.8-5.1,19.6-5.1 c9.5,0,9.5-37.5,19-37.5c9.8,0,9.8-2.4,19.6-2.4c9.5,0,9.5,3.6,19,3.6c9.8,0,9.8,45,19.6,45c9.8,0,9.8,18.9,19.6,18.9 c9.2,0,9.2-30.5,18.4-30.5c9.8,0,9.8-15.8,19.6-15.8c9.5,0,9.5,1.8,19,1.8c9.8,0,9.8-0.3,19.6-0.3c9.5,0,9.5,48.1,19,48.1 c9.8,0,9.8-19,19.6-19c9.8,0,9.8-41.7,19.6-41.7c9.5,0,9.5,7.8,19,7.8c9.8,0,9.8,16,19.6,16c9.5,0,9.5,32.8,19,32.8 c9.8,0,9.8,31.8,19.6,31.8s9.8-14.2,19.6-14.2c8.9,0,8.9-6.9,17.7-6.9c9.8,0,9.8-15.3,19.6-15.3c9.5,0,9.5,0.4,19,0.4 c9.8,0,9.8-32.8,19.6-32.8c9.5,0,9.5,40.9,19,40.9c9.8,0,9.8,11.1,19.6,11.1c9.8,0,9.8-43.9,19.6-43.9c9.5,0,9.5,20.7,19,20.7 c29.1,0,29.1,76,58.2,76c9.8,0,9.8-7,19.6-7c18.7,0,18.7-41,37.3-41c9.5,0,9.5-12.7,19-12.7c9.8,0,9.8-31.8,19.6-31.8 c9.5,0,9.5,30.3,19,30.3c9.8,0,9.8,10.8,19.6,10.8s9.8-16.1,19.6-16.1c9.5,0,9.5-7.5,19-7.5c9.8,0,9.8-3.7,19.6-3.7 c9.5,0,9.5,26.5,19,26.5v-4.8c-9.5,0-9.5-26.3-19-26.3c-9.8,0-9.8,4.2-19.6,4.2c-9.5,0-9.5,7.6-19,7.6 c-9.8,0-9.8,15.4-19.6,15.4s-9.8-10.5-19.6-10.5c-9.5,0-9.5-32-19-32c-9.8,0-9.8,31.1-19.6,31.1c-9.5,0-9.5,19.5-19,19.5 c-18.7,0-18.7,36.4-37.3,36.4c-9.8,0-9.8,7.3-19.6,7.3c-29.1,0-29.1-75.8-58.2-75.8c-9.5,0-9.5-20.6-19-20.6 c-9.8,0-9.8,44.2-19.6,44.2c-9.8,0-9.8-10.7-19.6-10.7c-9.5,0-9.5-37.7-19-37.7c-9.8,0-9.8,28.6-19.6,28.6c-9.5,0-9.5-1-19-1 c-9.8,0-9.8,16.1-19.6,16.1c-8.9,0-8.9,7.4-17.7,7.4c-9.8,0-9.8,14.2-19.6,14.2s-9.8-31.7-19.6-31.7c-9.5,0-9.5-33.5-19-33.5 c-9.8,0-9.8-15.6-19.6-15.6c-9.5,0-9.5-7.9-19-7.9c-9.8,0-9.8,41.8-19.6,41.8c-9.8,0-9.8,18.8-19.6,18.8 c-9.5,0-9.5-48.2-19-48.2c-9.8,0-9.8,0.3-19.6,0.3c-9.5,0-9.5-2.5-19-2.5c-9.8,0-9.8,16.5-19.6,16.5c-9.2,0-9.2,30.8-18.4,30.8 c-9.8,0-9.8-19.2-19.6-19.2c-9.8,0-9.8-44.6-19.6-44.6c-9.5,0-9.5-3.9-19-3.9c-9.8,0-9.8,2.9-19.6,2.9c-9.5,0-9.5,37.4-19,37.4 c-9.8,0-9.8,5.3-19.6,5.3c-9.8,0-9.8-48.8-19.6-48.8c-9.5,0-9.5,7.5-19,7.5c-9.8,0-9.8-9.6-19.6-9.6 c-19.3,0-19.3,25.1-38.6,25.1c-8.9,0-8.9,6.8-17.7,6.8c-19.6,0-19.6-32.6-39.2-32.6c-9.5,0-9.5-21.9-19-21.9 c-9.8,0-9.8-8.7-19.6-8.7c-9.5,0-9.5,43.2-19,43.2c-9.8,0-9.8,9.4-19.6,9.4c-9.8,0-9.8-23.7-19.6-23.7c-9.5,0-9.5-13.9-19-13.9 c-9.8,0-9.8-0.2-19.6-0.2c-9.5,0-9.5,14.4-19,14.4c-18.7,0-18.7,13.2-37.3,13.2c-9.8,0-9.8,12.3-19.6,12.3V569.4z"
  }), React.createElement("path", {
    id: "XMLID_1656_",
    style: {
      opacity: 0.75,
      fill: "#2A92C5"
    },
    d: "M46.6,573.3c9.8,0,9.8,3,19.6,3c18.7,0,18.7-8.8,37.3-8.8 c9.5,0,9.5-15,19-15c9.8,0,9.8-9,19.6-9c9.5,0,9.5,8,19,8c9.8,0,9.8,23.6,19.6,23.6c9.8,0,9.8-10,19.6-10 c9.5,0,9.5-28.7,19-28.7c9.8,0,9.8,3.3,19.6,3.3c9.5,0,9.5,22.4,19,22.4c19.6,0,19.6,25.3,39.2,25.3c8.9,0,8.9-11.6,17.7-11.6 c19.3,0,19.3-9,38.6-9c9.8,0,9.8-2.1,19.6-2.1c9.5,0,9.5-12.8,19-12.8c9.8,0,9.8,53.2,19.6,53.2c9.8,0,9.8-1.6,19.6-1.6 c9.5,0,9.5-41.8,19-41.8c9.8,0,9.8,8,19.6,8c9.5,0,9.5,2.5,19,2.5c9.8,0,9.8,36.7,19.6,36.7c9.8,0,9.8,19.7,19.6,19.7 c9.2,0,9.2-26.1,18.4-26.1c9.8,0,9.8-9.5,19.6-9.5c9.5,0,9.5-13.9,19-13.9c9.8,0,9.8,5.5,19.6,5.5c9.5,0,9.5,51.9,19,51.9 c9.8,0,9.8-24,19.6-24c9.8,0,9.8-38.1,19.6-38.1c9.5,0,9.5,7.9,19,7.9c9.8,0,9.8,17,19.6,17c9.5,0,9.5,31.2,19,31.2 c9.8,0,9.8,14.5,19.6,14.5s9.8-4.1,19.6-4.1c8.9,0,8.9-7.4,17.7-7.4c9.8,0,9.8-8.1,19.6-8.1c9.5,0,9.5-5.9,19-5.9 c9.8,0,9.8-36.5,19.6-36.5c9.5,0,9.5,34.5,19,34.5c9.8,0,9.8,25,19.6,25c9.8,0,9.8-43.6,19.6-43.6c9.5,0,9.5,24.3,19,24.3 c29.1,0,29.1,72.5,58.2,72.5c9.8,0,9.8-10.7,19.6-10.7c18.7,0,18.7-45.1,37.3-45.1c9.5,0,9.5-0.2,19-0.2c9.8,0,9.8-25,19.6-25 c9.5,0,9.5-2.9,19-2.9c9.8,0,9.8,29.2,19.6,29.2s9.8-16.9,19.6-16.9c9.5,0,9.5-7.2,19-7.2c9.8,0,9.8,2.3,19.6,2.3 c9.5,0,9.5,20.8,19,20.8v-4.2c-9.5,0-9.5-20.5-19-20.5c-9.8,0-9.8-2.3-19.6-2.3c-9.5,0-9.5,7.5-19,7.5 c-9.8,0-9.8,16.1-19.6,16.1s-9.8-30-19.6-30c-9.5,0-9.5,3.2-19,3.2c-9.8,0-9.8,25.2-19.6,25.2c-9.5,0-9.5,4.9-19,4.9 c-18.7,0-18.7,41-37.3,41c-9.8,0-9.8,11.9-19.6,11.9c-29.1,0-29.1-72.1-58.2-72.1c-9.5,0-9.5-24.3-19-24.3 c-9.8,0-9.8,43.4-19.6,43.4c-9.8,0-9.8-25.6-19.6-25.6c-9.5,0-9.5-31.1-19-31.1c-9.8,0-9.8,32.8-19.6,32.8 c-9.5,0-9.5,5.8-19,5.8c-9.8,0-9.8,9.1-19.6,9.1c-8.9,0-8.9,6.9-17.7,6.9c-9.8,0-9.8,3.8-19.6,3.8s-9.8-13.1-19.6-13.1 c-9.5,0-9.5-31.7-19-31.7c-9.8,0-9.8-16.7-19.6-16.7c-9.5,0-9.5-7.9-19-7.9c-9.8,0-9.8,37.8-19.6,37.8 c-9.8,0-9.8,23.7-19.6,23.7c-9.5,0-9.5-52.4-19-52.4c-9.8,0-9.8-5-19.6-5c-9.5,0-9.5,14-19,14c-9.8,0-9.8,9.8-19.6,9.8 c-9.2,0-9.2,25.7-18.4,25.7c-9.8,0-9.8-19.2-19.6-19.2c-9.8,0-9.8-36.6-19.6-36.6c-9.5,0-9.5-2.6-19-2.6 c-9.8,0-9.8-7.7-19.6-7.7c-9.5,0-9.5,41.9-19,41.9c-9.8,0-9.8,1-19.6,1c-9.8,0-9.8-53-19.6-53c-9.5,0-9.5,12.6-19,12.6 c-9.8,0-9.8,2.2-19.6,2.2c-19.3,0-19.3,8.9-38.6,8.9c-8.9,0-8.9,11.6-17.7,11.6c-19.6,0-19.6-24.6-39.2-24.6 c-9.5,0-9.5-23.3-19-23.3c-9.8,0-9.8-2.5-19.6-2.5c-9.5,0-9.5,28.8-19,28.8c-9.8,0-9.8,9.5-19.6,9.5c-9.8,0-9.8-23.8-19.6-23.8 c-9.5,0-9.5-8.1-19-8.1c-9.8,0-9.8,9.5-19.6,9.5c-9.5,0-9.5,15-19,15c-18.7,0-18.7,8.2-37.3,8.2c-9.8,0-9.8-2.5-19.6-2.5V573.3z "
  }), React.createElement("text", {
    id: "XMLID_1653_",
    transform: "matrix(1 0 0 1 46.4165 718.2099)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: 15
    }
  }, "2014"), React.createElement("text", {
    id: "XMLID_1641_",
    transform: "matrix(1 0 0 1 261.1577 718.2099)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: 15
    }
  }, "2015"), React.createElement("text", {
    id: "XMLID_1629_",
    transform: "matrix(1 0 0 1 492.1509 718.2099)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: 15
    }
  }, "2016"), React.createElement("text", {
    id: "XMLID_1615_",
    transform: "matrix(1 0 0 1 723.774 718.2099)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: 15
    }
  }, "2017"), React.createElement("text", {
    id: "XMLID_1597_",
    transform: "matrix(1 0 0 1 954.7681 719.2107)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: 15
    }
  }, "2018"), React.createElement("g", {
    id: "XMLID_1585_"
  }, React.createElement("path", {
    id: "XMLID_1655_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    d: "M47,704v-4.5h1136v4.5"
  }), React.createElement("line", {
    id: "XMLID_1654_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 47,
    y1: 699.1,
    x2: 47,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1651_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 104,
    y1: 699.1,
    x2: 104,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1648_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 161.6,
    y1: 699.1,
    x2: 161.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1645_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 219.8,
    y1: 699.1,
    x2: 219.8,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1642_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 278,
    y1: 699.1,
    x2: 278,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1639_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 335,
    y1: 699.1,
    x2: 335,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1636_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 392.6,
    y1: 699.1,
    x2: 392.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1633_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 450.8,
    y1: 699.1,
    x2: 450.8,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1630_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 509,
    y1: 699.1,
    x2: 509,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1627_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 566.6,
    y1: 699.1,
    x2: 566.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1624_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 624.2,
    y1: 699.1,
    x2: 624.2,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1621_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 682.4,
    y1: 699.1,
    x2: 682.4,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1618_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 740.6,
    y1: 699.1,
    x2: 740.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1611_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 797.6,
    y1: 699.1,
    x2: 797.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1605_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 855.2,
    y1: 699.1,
    x2: 855.2,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1601_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 913.4,
    y1: 699.1,
    x2: 913.4,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1598_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 971.6,
    y1: 699.1,
    x2: 971.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1595_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 1028.6,
    y1: 699.1,
    x2: 1028.6,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1591_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 1086.2,
    y1: 699.1,
    x2: 1086.2,
    y2: 704
  }), React.createElement("line", {
    id: "XMLID_1588_",
    style: {
      fill: "none",
      stroke: "#CCCCCC"
    },
    x1: 1144.4,
    y1: 699.1,
    x2: 1144.4,
    y2: 704
  })), React.createElement("g", {
    id: "XMLID_1586_"
  }, React.createElement("text", {
    id: "XMLID_1650_",
    transform: "matrix(1 0 0 1 95.8652 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "April"), React.createElement("text", {
    id: "XMLID_1647_",
    transform: "matrix(1 0 0 1 154.3555 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "July"), React.createElement("text", {
    id: "XMLID_1644_",
    transform: "matrix(1 0 0 1 205.3623 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "October"), React.createElement("text", {
    id: "XMLID_1638_",
    transform: "matrix(1 0 0 1 326.8574 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "April"), React.createElement("text", {
    id: "XMLID_1635_",
    transform: "matrix(1 0 0 1 385.3486 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "July"), React.createElement("text", {
    id: "XMLID_1632_",
    transform: "matrix(1 0 0 1 436.3545 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "October"), React.createElement("text", {
    id: "XMLID_1626_",
    transform: "matrix(1 0 0 1 558.4814 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "April"), React.createElement("text", {
    id: "XMLID_1623_",
    transform: "matrix(1 0 0 1 616.9736 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "July"), React.createElement("text", {
    id: "XMLID_1620_",
    transform: "matrix(1 0 0 1 667.9795 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "October"), React.createElement("text", {
    id: "XMLID_1609_",
    transform: "matrix(1 0 0 1 789.4746 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "April"), React.createElement("text", {
    id: "XMLID_1603_",
    transform: "matrix(1 0 0 1 847.9668 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "July"), React.createElement("text", {
    id: "XMLID_1600_",
    transform: "matrix(1 0 0 1 898.9717 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "October"), React.createElement("text", {
    id: "XMLID_1594_",
    transform: "matrix(1 0 0 1 1020.4668 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "April"), React.createElement("text", {
    id: "XMLID_1590_",
    transform: "matrix(1 0 0 1 1078.958 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "July"), React.createElement("text", {
    id: "XMLID_1587_",
    transform: "matrix(1 0 0 1 1129.9639 715.2075)",
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "October"))), React.createElement("g", {
    id: "XMLID_139_"
  }, React.createElement("text", {
    id: "XMLID_18341_",
    transform: "matrix(1 0 0 1 286.5889 245.0311)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "Korea         "), React.createElement("text", {
    id: "XMLID_18340_",
    transform: "matrix(1 0 0 1 292.9487 324.7719)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "USA"), React.createElement("text", {
    id: "XMLID_18339_",
    transform: "matrix(1 0 0 1 287.4365 374.8654)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "China"), React.createElement("text", {
    id: "XMLID_18338_",
    transform: "matrix(1 0 0 1 331.4424 404.3156)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Japan"), React.createElement("text", {
    id: "XMLID_15235_",
    transform: "matrix(0.9931 -0.1169 0.1169 0.9931 317.1838 484.5526)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Canada"), React.createElement("text", {
    id: "XMLID_15232_",
    transform: "matrix(1 0 0 1 317.7505 432.1021)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Australia"), React.createElement("text", {
    id: "XMLID_15233_",
    transform: "matrix(1 0 0 1 323.7065 449.7057)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Singapore"), React.createElement("text", {
    id: "XMLID_15236_",
    transform: "matrix(0.9886 -0.1507 0.1507 0.9886 321.2556 499.8555)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Taiwan"), React.createElement("text", {
    id: "XMLID_15237_",
    transform: "matrix(0.9918 -0.1275 0.1275 0.9918 316.9369 515.3801)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Malaysia"), React.createElement("text", {
    id: "XMLID_15238_",
    transform: "matrix(0.9992 -3.916000e-002 3.916000e-002 0.9992 340.2718 523.2788)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 8
    }
  }, "Hongkong"), React.createElement("text", {
    id: "XMLID_15234_",
    transform: "matrix(1 0 0 1 325.4609 466.9557)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "UK")), React.createElement("g", {
    id: "XMLID_142_"
  }, React.createElement("text", {
    id: "XMLID_3_",
    transform: "matrix(1 0 0 1 900.5889 217.7252)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "Korea         "), React.createElement("text", {
    id: "XMLID_4_",
    transform: "matrix(1 0 0 1 963.9487 412.0658)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "USA"), React.createElement("text", {
    id: "XMLID_5_",
    transform: "matrix(1 0 0 1 936.4365 316.0937)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "China"), React.createElement("text", {
    id: "XMLID_6_",
    transform: "matrix(1 0 0 1 992.4424 470.3075)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Japan"), React.createElement("text", {
    id: "XMLID_9_",
    transform: "matrix(0.8439 -0.5364 0.5364 0.8439 995.8041 566.1143)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Canada"), React.createElement("text", {
    id: "XMLID_7_",
    transform: "matrix(1 0 0 1 953.5273 520.4113)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Australia"), React.createElement("text", {
    id: "XMLID_10_",
    transform: "matrix(0.8175 -0.5759 0.5759 0.8175 999.731 543.199)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Taiwan"), React.createElement("text", {
    id: "XMLID_11_",
    transform: "matrix(0.8175 -0.5759 0.5759 0.8175 991.5419 605.899)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Singapore"), React.createElement("text", {
    id: "XMLID_7457_",
    transform: "matrix(0.9959 -9.072000e-002 9.072000e-002 0.9959 964.2832 633.6232)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Malaysia"), React.createElement("text", {
    id: "XMLID_7461_",
    transform: "matrix(0.9959 -9.072000e-002 9.072000e-002 0.9959 988.0489 643.9137)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Germany"), React.createElement("text", {
    id: "XMLID_7462_",
    transform: "matrix(0.9959 -9.072000e-002 9.072000e-002 0.9959 989.2551 654.7073)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "France"), React.createElement("text", {
    id: "XMLID_7463_",
    transform: "matrix(0.9959 -9.072000e-002 9.072000e-002 0.9959 989.4163 665.0839)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "India"), React.createElement("text", {
    id: "XMLID_7464_",
    transform: "matrix(0.9959 -9.072000e-002 9.072000e-002 0.9959 962.5288 675.5837)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Indonesia"), React.createElement("text", {
    id: "XMLID_7458_",
    transform: "matrix(0.9811 -0.1933 0.1933 0.9811 989.4313 618.1968)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Hongkong"), React.createElement("text", {
    id: "XMLID_8_",
    transform: "matrix(1 0 0 1 967.4878 588.1902)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "UK")), React.createElement("rect", {
    id: "XMLID_11481_",
    x: 362.1,
    y: 588.2,
    style: {
      fill: "none"
    },
    width: 58.6,
    height: 91.7
  }), React.createElement("text", {
    id: "XMLID_11480_",
    transform: "matrix(1 0 0 1 362.1448 596.49)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "India"), React.createElement("tspan", {
    x: 0,
    y: 10,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Germany"), React.createElement("tspan", {
    x: 0,
    y: 20,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Thailand"), React.createElement("tspan", {
    x: 0,
    y: 30,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "France"), React.createElement("tspan", {
    x: 0,
    y: 40,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Indonesia"), React.createElement("tspan", {
    x: 0,
    y: 50,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Saudi Arabia"), React.createElement("tspan", {
    x: 0,
    y: 60,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Vietnam"), React.createElement("tspan", {
    x: 0,
    y: 70,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Netherlands"), React.createElement("tspan", {
    x: 0,
    y: 80,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 10
    }
  }, "Guam")), React.createElement("g", {
    id: "XMLID_968_"
  }, React.createElement("g", {
    id: "XMLID_5208_"
  }, React.createElement("line", {
    id: "XMLID_5213_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10
    },
    x1: 971.5,
    y1: 49,
    x2: 971.5,
    y2: 51
  }), React.createElement("line", {
    id: "XMLID_5211_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10,
      strokeDasharray: "4,3"
    },
    x1: 971.5,
    y1: 54,
    x2: 971.5,
    y2: 696
  }), React.createElement("line", {
    id: "XMLID_5210_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10
    },
    x1: 971.5,
    y1: 697,
    x2: 971.5,
    y2: 699
  }))), React.createElement("g", {
    id: "XMLID_3414_"
  }, React.createElement("g", {
    id: "XMLID_5201_"
  }, React.createElement("line", {
    id: "XMLID_5205_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10
    },
    x1: 525.5,
    y1: 49,
    x2: 525.5,
    y2: 51
  }), React.createElement("line", {
    id: "XMLID_5204_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10,
      strokeDasharray: "4,3"
    },
    x1: 525.5,
    y1: 54,
    x2: 525.5,
    y2: 696
  }), React.createElement("line", {
    id: "XMLID_5202_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10
    },
    x1: 525.5,
    y1: 697,
    x2: 525.5,
    y2: 699
  }))), React.createElement("g", {
    id: "XMLID_3420_"
  }, React.createElement("g", {
    id: "XMLID_5193_"
  }, React.createElement("line", {
    id: "XMLID_5198_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10
    },
    x1: 624.5,
    y1: 49,
    x2: 624.5,
    y2: 51
  }), React.createElement("line", {
    id: "XMLID_5196_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10,
      strokeDasharray: "4,3"
    },
    x1: 624.5,
    y1: 54,
    x2: 624.5,
    y2: 696
  }), React.createElement("line", {
    id: "XMLID_5195_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeMiterlimit: 10
    },
    x1: 624.5,
    y1: 697,
    x2: 624.5,
    y2: 699
  }))), React.createElement("g", {
    id: "XMLID_5142_"
  }, React.createElement("text", {
    id: "XMLID_1702_",
    transform: "matrix(1 0 0 1 1236.0452 177.5876)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "Korea         "), React.createElement("text", {
    id: "XMLID_1717_",
    transform: "matrix(1 0 0 1 1236.0452 286.2535)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "USA"), React.createElement("text", {
    id: "XMLID_1718_",
    transform: "matrix(1 0 0 1 1236.0452 386.5869)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 16
    }
  }, "China"), React.createElement("text", {
    id: "XMLID_1719_",
    transform: "matrix(1 0 0 1 1236.0452 457.6552)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Japan"), React.createElement("text", {
    id: "XMLID_1720_",
    transform: "matrix(1 0 0 1 1236.0452 500.7859)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Canada"), React.createElement("text", {
    id: "XMLID_1728_",
    transform: "matrix(1 0 0 1 1236.0452 527.5388)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Australia"), React.createElement("text", {
    id: "XMLID_1721_",
    transform: "matrix(1 0 0 1 1236.0449 549.4109)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "UK"), React.createElement("text", {
    id: "XMLID_1722_",
    transform: "matrix(1 0 0 1 1236.0447 571.8571)",
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Taiwan"), React.createElement("rect", {
    id: "XMLID_1715_",
    x: 1236,
    y: 578.8,
    style: {
      fill: "none"
    },
    width: 91,
    height: 172.4
  }), React.createElement("text", {
    id: "XMLID_1768_",
    transform: "matrix(1 0 0 1 1236.0444 588.7224)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Singapore"), React.createElement("tspan", {
    x: 0,
    y: 14.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Malaysia"), React.createElement("tspan", {
    x: 0,
    y: 28.8,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Germany"), React.createElement("tspan", {
    x: 0,
    y: 43.2,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Indonesia"), React.createElement("tspan", {
    x: 0,
    y: 57.6,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "France"), React.createElement("tspan", {
    x: 0,
    y: 72,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Thailand"), React.createElement("tspan", {
    x: 0,
    y: 86.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Vietnam"), React.createElement("tspan", {
    x: 0,
    y: 100.8,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Saudi Arabia"), React.createElement("tspan", {
    x: 0,
    y: 115.2,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Netherlands"), React.createElement("tspan", {
    x: 0,
    y: 129.6,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Guam"), React.createElement("tspan", {
    x: 0,
    y: 144,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Hongkong"), React.createElement("tspan", {
    x: 0,
    y: 158.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "India")), React.createElement("g", {
    id: "XMLID_11770_"
  }, React.createElement("line", {
    id: "XMLID_674_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 584.5,
    x2: 1224,
    y2: 584.5
  }), React.createElement("line", {
    id: "XMLID_746_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 566.5,
    x2: 1224,
    y2: 566.5
  }), React.createElement("line", {
    id: "XMLID_748_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 544.5,
    x2: 1224,
    y2: 544.5
  }), React.createElement("line", {
    id: "XMLID_750_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 522.5,
    x2: 1224,
    y2: 522.5
  }), React.createElement("line", {
    id: "XMLID_752_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 496.5,
    x2: 1224,
    y2: 496.5
  }), React.createElement("line", {
    id: "XMLID_754_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 453.5,
    x2: 1224,
    y2: 453.5
  }), React.createElement("line", {
    id: "XMLID_756_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 380.5,
    x2: 1224,
    y2: 380.5
  }), React.createElement("line", {
    id: "XMLID_758_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 280.5,
    x2: 1224,
    y2: 280.5
  }), React.createElement("line", {
    id: "XMLID_760_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 172.5,
    x2: 1224,
    y2: 172.5
  }), React.createElement("line", {
    id: "XMLID_676_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 598.5,
    x2: 1224,
    y2: 598.5
  }), React.createElement("line", {
    id: "XMLID_678_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 609.5,
    x2: 1224,
    y2: 612.8
  }), React.createElement("line", {
    id: "XMLID_680_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 618.5,
    x2: 1224,
    y2: 628
  }), React.createElement("line", {
    id: "XMLID_682_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 625.5,
    x2: 1224,
    y2: 642.2
  }), React.createElement("line", {
    id: "XMLID_732_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 631.5,
    x2: 1224,
    y2: 656.2
  }), React.createElement("line", {
    id: "XMLID_734_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 637.5,
    x2: 1224,
    y2: 671
  }), React.createElement("line", {
    id: "XMLID_736_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 643.5,
    x2: 1224,
    y2: 685.3
  }), React.createElement("line", {
    id: "XMLID_738_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 648.5,
    x2: 1224,
    y2: 699.1
  }), React.createElement("line", {
    id: "XMLID_740_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 652.5,
    x2: 1224,
    y2: 713.2
  }), React.createElement("line", {
    id: "XMLID_742_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 655.5,
    x2: 1224,
    y2: 728
  }), React.createElement("line", {
    id: "XMLID_744_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    x1: 1186,
    y1: 657.1,
    x2: 1224,
    y2: 741.5
  })), React.createElement("circle", {
    id: "XMLID_11635_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 172.5,
    r: 8.9
  }), React.createElement("g", {
    id: "XMLID_11632_"
  }, React.createElement("text", {
    id: "XMLID_64_",
    transform: "matrix(1 0 0 1 1220.4669 175.9463)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "11.0312px"
    }
  }, "1")), React.createElement("circle", {
    id: "XMLID_11638_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 280.5,
    r: 8.9
  }), React.createElement("g", {
    id: "XMLID_11634_"
  }, React.createElement("text", {
    id: "XMLID_62_",
    transform: "matrix(1 0 0 1 1220.4669 283.9463)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "11.0312px"
    }
  }, "2")), React.createElement("circle", {
    id: "XMLID_11640_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 380.5,
    r: 8.9
  }), React.createElement("g", {
    id: "XMLID_11636_"
  }, React.createElement("text", {
    id: "XMLID_60_",
    transform: "matrix(1 0 0 1 1220.4669 383.9462)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "11.0312px"
    }
  }, "3")), React.createElement("circle", {
    id: "XMLID_11642_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 453.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11637_"
  }, React.createElement("text", {
    id: "XMLID_58_",
    transform: "matrix(1 0 0 1 1221.4375 456.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "4")), React.createElement("circle", {
    id: "XMLID_11644_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 496.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11639_"
  }, React.createElement("text", {
    id: "XMLID_56_",
    transform: "matrix(1 0 0 1 1221.4375 499.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "5")), React.createElement("circle", {
    id: "XMLID_11647_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 522.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11641_"
  }, React.createElement("text", {
    id: "XMLID_54_",
    transform: "matrix(1 0 0 1 1221.4375 525.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "6")), React.createElement("circle", {
    id: "XMLID_11651_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 544.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11643_"
  }, React.createElement("text", {
    id: "XMLID_52_",
    transform: "matrix(1 0 0 1 1221.4375 547.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "7")), React.createElement("circle", {
    id: "XMLID_11655_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 566.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11646_"
  }, React.createElement("text", {
    id: "XMLID_50_",
    transform: "matrix(1 0 0 1 1221.4375 569.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "8")), React.createElement("circle", {
    id: "XMLID_11659_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 584.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11650_"
  }, React.createElement("text", {
    id: "XMLID_48_",
    transform: "matrix(1 0 0 1 1221.4375 587.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "9")), React.createElement("circle", {
    id: "XMLID_11663_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 598.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11654_"
  }, React.createElement("text", {
    id: "XMLID_46_",
    transform: "matrix(1 0 0 1 1219.4961 601.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "10")), React.createElement("circle", {
    id: "XMLID_11667_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 613.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11658_"
  }, React.createElement("text", {
    id: "XMLID_44_",
    transform: "matrix(1 0 0 1 1219.4961 616.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "11")), React.createElement("circle", {
    id: "XMLID_11671_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 628.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11662_"
  }, React.createElement("text", {
    id: "XMLID_42_",
    transform: "matrix(1 0 0 1 1219.4961 631.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "12")), React.createElement("circle", {
    id: "XMLID_11675_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 642.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11666_"
  }, React.createElement("text", {
    id: "XMLID_40_",
    transform: "matrix(1 0 0 1 1219.4961 645.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "13")), React.createElement("circle", {
    id: "XMLID_11679_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 656.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11670_"
  }, React.createElement("text", {
    id: "XMLID_38_",
    transform: "matrix(1 0 0 1 1219.4961 659.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "14")), React.createElement("circle", {
    id: "XMLID_11683_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 671.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11674_"
  }, React.createElement("text", {
    id: "XMLID_36_",
    transform: "matrix(1 0 0 1 1219.4961 674.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "15")), React.createElement("circle", {
    id: "XMLID_11687_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 685.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11678_"
  }, React.createElement("text", {
    id: "XMLID_32_",
    transform: "matrix(1 0 0 1 1219.4961 688.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "16")), React.createElement("circle", {
    id: "XMLID_11691_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 699.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11682_"
  }, React.createElement("text", {
    id: "XMLID_30_",
    transform: "matrix(1 0 0 1 1219.4961 702.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "17")), React.createElement("circle", {
    id: "XMLID_11695_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 714.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11686_"
  }, React.createElement("text", {
    id: "XMLID_28_",
    transform: "matrix(1 0 0 1 1219.4961 717.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "18")), React.createElement("circle", {
    id: "XMLID_11699_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 728.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11690_"
  }, React.createElement("text", {
    id: "XMLID_61_",
    transform: "matrix(1 0 0 1 1219.4961 731.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "19")), React.createElement("circle", {
    id: "XMLID_11703_",
    style: {
      fill: "#333333"
    },
    cx: 1223.6,
    cy: 742.5,
    r: 6
  }), React.createElement("g", {
    id: "XMLID_11694_"
  }, React.createElement("text", {
    id: "XMLID_63_",
    transform: "matrix(1 0 0 1 1219.4961 745.0615)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: "7.3541px"
    }
  }, "20"))), React.createElement("polyline", {
    id: "XMLID_804_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "354.5,531  354.5,593.5 359,593.5  "
  }), React.createElement("polyline", {
    id: "XMLID_606_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "349.5,538  349.5,603.5 359,603.5  "
  }), React.createElement("polyline", {
    id: "XMLID_808_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "345.5,546  345.5,613.5 359,613.5  "
  }), React.createElement("polyline", {
    id: "XMLID_810_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "340.5,551  340.5,622.5 359,622.5  "
  }), React.createElement("polyline", {
    id: "XMLID_813_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "335.5,559  335.5,633.5 359,633.5  "
  }), React.createElement("polyline", {
    id: "XMLID_864_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "331.5,559  331.5,643.5 359,643.5  "
  }), React.createElement("polyline", {
    id: "XMLID_863_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "326.5,573  326.5,652.5 359,652.5  "
  }), React.createElement("polyline", {
    id: "XMLID_862_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "322.5,578  322.5,663.5 359,663.5  "
  }), React.createElement("polyline", {
    id: "XMLID_113_",
    style: {
      fill: "none",
      stroke: "#333333",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "317.5,582  317.5,673.5 359,673.5  "
  }), React.createElement("rect", {
    id: "XMLID_972_",
    x: 779.1,
    y: 48.8,
    style: {
      fill: "none"
    },
    width: 181.5,
    height: 42.5
  }), React.createElement("text", {
    id: "XMLID_970_",
    transform: "matrix(1 0 0 1 779.0739 57.3221)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "The highest number of tourist "), React.createElement("tspan", {
    x: 0,
    y: 14.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "arrival was on January 2018 ever "), React.createElement("tspan", {
    x: 0,
    y: 28.8,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "since 2014.")), React.createElement("rect", {
    id: "XMLID_856_",
    x: 1214.6,
    y: 81,
    style: {
      fill: "none"
    },
    width: 103.4,
    height: 61.3
  }), React.createElement("text", {
    id: "XMLID_814_",
    transform: "matrix(1 0 0 1 1214.6152 89.5439)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Top 20 foreign "), React.createElement("tspan", {
    x: 0,
    y: 14.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "tourists in the "), React.createElement("tspan", {
    x: 0,
    y: 28.8,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Philippines as of "), React.createElement("tspan", {
    x: 0,
    y: 43.2,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "December 2018:")), React.createElement("rect", {
    id: "XMLID_3428_",
    x: 537.3,
    y: 48.8,
    style: {
      fill: "none"
    },
    width: 77.3,
    height: 98.7
  }), React.createElement("text", {
    id: "XMLID_3426_",
    transform: "matrix(1 0 0 1 539.796 57.3221)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "The months of "), React.createElement("tspan", {
    x: 2.8,
    y: 14.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "February and "), React.createElement("tspan", {
    x: 3.9,
    y: 28.8,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "July tends to "), React.createElement("tspan", {
    x: 5.2,
    y: 43.2,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "be the cyclic "), React.createElement("tspan", {
    x: 5.1,
    y: 57.6,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "peak season "), React.createElement("tspan", {
    x: 11.2,
    y: 72,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "for tourist "), React.createElement("tspan", {
    x: 17.6,
    y: 86.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "arrivals")), React.createElement("rect", {
    id: "XMLID_35_",
    x: 48,
    y: 48.8,
    style: {
      fill: "none"
    },
    width: 269.8,
    height: 72.2
  }), React.createElement("text", {
    id: "XMLID_34_",
    transform: "matrix(1 0 0 1 47.9998 57.3221)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Korea has maintainted it\u2019s top spot having the most "), React.createElement("tspan", {
    x: 0,
    y: 14.4,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "number of foreign tourists in the Philippines. USA and "), React.createElement("tspan", {
    x: 0,
    y: 28.8,
    style: {
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "China have been vying for the second spot since 2014.")), React.createElement("rect", {
    id: "XMLID_1000_",
    x: 58,
    y: 604.8,
    style: {
      fill: "none"
    },
    width: 237.8,
    height: 83.3
  }), React.createElement("text", {
    id: "XMLID_994_",
    transform: "matrix(1 0 0 1 58.0042 613.2096)"
  }, React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 700,
      fontSize: 12
    }
  }, "Data source:"), React.createElement("tspan", {
    x: 0,
    y: 14.4,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Tourism Demand Statistics - Department of "), React.createElement("tspan", {
    x: 0,
    y: 28.8,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "Tourism, Retrieved from "), React.createElement("tspan", {
    x: 124,
    y: 28.8,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontStyle: "400i",
      fontSize: 12
    }
  }, "www.tourism.gov.ph/"), React.createElement("tspan", {
    x: 0,
    y: 43.2,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontStyle: "400i",
      fontSize: 12
    }
  }, "tourism_dem_sup_pub.aspx"), React.createElement("tspan", {
    x: 139.5,
    y: 43.2,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, ", Accessed on "), React.createElement("tspan", {
    x: 0,
    y: 57.6,
    style: {
      fill: "#333333",
      fontFamily: "'Source Sans Pro'",
      fontWeight: 400,
      fontSize: 12
    }
  }, "October 7, 2019"))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTouristArrivalPhBumpchartWorldwideWide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tourist_arrival_ph_bumpchart_worldwide_wide.b2abfb7c.svg";
export { ForwardRef as ReactComponent };